import { Modal } from "./Modal.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";
import { FormatHelper } from "../Helpers/FormatHelper.js";
import { PmDRSDatalayer } from "../Datalayer/PmDRSDatalayer.js";

export class PaymentSection {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAt = "your-payment-section";
        this.makeDownPayment = false;
        this.addingPaymentElement = false;
        this.validPayment = true;

        // true once the customer changes a field away from whatever it loaded/defaulted to,
        // so leads can tell a deliberate choice apart from an untouched default
        this.termTouched = false;
        this.mpyTouched = false;
        this.cashDownTouched = false;
        this.makeDownPaymentTouched = false;
        this.creditScoreTouched = false;

        //TODO replace with a public key set in config
        this.stripe = null;
        if ("Stripe" in window) {
            let pmStripeKey = "pk_test_51MlJ42AKJL8lPTmAIZJzuAdJQmHUjvPqWC7Qsfe4wxwKYWA783N3xr8smnE5NSi1PecVuGDJ0cc4DSDwTjvsgqBv00mUMAqcI4";
            let stripeKeys = {
                'themotorcycleshop': 'pk_live_51S0Xxt6vVVV4WKNyOtwWZVYPfIUoaVqHpjwQBs9uhPRTIg28459RLTIZQtuG6WPJIw9NwAvT1v3qEqfW9feo7odH00GGf9hI1Q'
            }
            let siteKey = stripeKeys[this.app.pmdrs.config.accountId];
            this.stripe = Stripe(
                siteKey || pmStripeKey
            );
        }
        this.stripeElements = null;
        this.downPaymentDeposit = 0;
        this.taxesValue = 0;//this variable doesn't work for any driver, it's a PM thing. //TODO redesign solution
        this.tradeInData = {
            tradeInEstimate: 0,
        };
        this.enabled = true;
        this.taxes = false;
        this.feesAndTaxesCompleted = false; //true once the customer clicks the Add Fees & Taxes / Apply button, regardless of outcome
        // last paymentRecalculated snapshot fired per deal type, so an identical result
        // reported multiple times in immediate succession (e.g. a re-render loop) only
        // tracks once - see trackPaymentRecalculated()
        this.lastRecalcSnapshot = {};
        this.disableTaxesSection = ['fresnochryslerjeep', 'clovischryslerdodgejeepram',
            'planetchryslerdodgejeepram']
            .includes(this.app.pmdrs.config.accountId)
            // PmRates (fixed in-house rate) dealers have no real tax data — this button's
            // "Add Fees & Taxes" figure comes from LenderDesk's real fees-and-taxes
            // endpoint, which a PmRates response never populates, so it always resolved
            // to a misleading "Remove $0.00 in taxes" instead of erroring or doing nothing.
            || Object.values(this.app.pmdrs.dataDriver.initialPayments || {}).some((p) => p?.pmRates);

        this.easyRideInfoModal = new Modal(
            this.app,
            "start-easyrideinfo-modal",
            this.getEasyRideInfoModal(),
            null,
            "easyrideinfo-section"
        );
        this.easyRideInfoModal.init();
    }

    init(containerElement) {
        containerElement.insertAdjacentHTML('beforeend', this.getHtml());
        //populate
        this.populateTermSelect("term", "finance");

        // let isDucati = this.app.isVehicleDucati();
        // if (!this.app.isBMW() && !this.app.isBMWPolaris() && !isDucati && !this.app.isVehicleTriumph()
        // && !this.app.isVehicleOnlyFinance(this.app.config.vehicle.make)) {
        //     // this.populateMilesPerYearSelect("miles-per-year");
        //     this.populateMpySelect();
        //     this.populateTermSelect("term-lease", "lease");
        // // } else if (isDucati) {
        // //     this.populateTermSelect("term-premier", "premier");
        // // } else if (this.app.isVehicleTriumph()) {
        // //     this.populateTermSelect("term-ttf", "ttf");
        // // } else if (this.app.isBMW()) {
        // }
        this.populateMpySelect();
        this.populateLenders();
        this.populateTermSelect("term-lease", "lease");
        this.populateTermSelect("term-balloon", "balloon");
        this.populateCreditScoreSelect();
        //Down payment only on bmwdrs or dev
        //Stripe
        if (["bmwdrs",'bmwdrs2','indian4', 'devmotosamerica', 'victorcdjrdemo', 'speeddra', 'speeddra2', 'themotorcycleshop']
            .includes(this.app.pmdrs.config.accountId)) {
            document.querySelector(this.getSelector(".down-payment-container")).style.display = "block";
        }
        // this.showHideEasyRideBox();
        // this.showHideLeaseBox();
        // this.showPremierBox();
        // this.showHideTTFBox();
        this.eventHandlers();
        this.setDefaultDownPayment();
        this.hideTaxesSection();
        this.setMaxCashDownInput();
        this.setZipCodeText();
        this.validateDoNotIncludeTaxes();

        if (this.app.siteSettings.contactFormAtBottom) {
            // the contact form section sits right after this one and owns the single
            // validated submit button there; this one only enforces native HTML "required"
            // and bypasses validateContactInformation(), so hide it to avoid a second,
            // weaker submit path
            let submitBtn = document.querySelector(this.getSelector('.submit-button'));
            if (submitBtn) submitBtn.style.display = 'none';
        }
        // when sectionsUnlockedByDefault instead, the contact form stays in its classic
        // position above accessories/trade-in/payment — this button stays visible as a
        // shortcut for users who configure their deal before scrolling back up, but its
        // click handler (see eventHandlers()) proxies to the contact form's own validated
        // submit instead of the native-form-submit bypass

        // Settings-driven, not isFCA()-driven — a hardcoded OEM check silently broke
        // for any non-FCA site that also wanted this button, and meant the URL/text
        // could never differ per site (see startApplicationButtonUrl below, which
        // used to be a hardcoded PM-relative path that couldn't work on non-PM sites).
        if (this.app.siteSettings.startApplicationButtonEnabled) {
            // Default label is "Pre-qualify now", not "Start Application" — confirmed
            // rename decision (2026-08-20 meeting), to match branding used elsewhere.
            let label = this.app.siteSettings.startApplicationButtonText || "Pre-qualify now";
            // DOMHelper.setInnerHTML/removeClass take a selector, not an element (only
            // removeClass happens to also accept one) — passing the queried element
            // itself here used to throw inside setInnerHTML's querySelectorAll call,
            // silently aborting before removeClass ever ran.
            DOMHelper.setInnerHTML(this.getSelector('.start-application-button'), label + ' <i class="pmdrs-fa pmdrs-fa-external-link"></i>');
            DOMHelper.removeClass(this.getSelector('.start-application-button'), 'dn');
        }

        this.setPrivacyPolicyLink();
    }

    // startApplicationButtonUrl can be a full absolute URL (any host — needed for a
    // non-PM/VIN-only site whose "pre-approved"-style page doesn't live on this DRA's
    // own domain) or a relative path, resolved against this site's own host via
    // PmDealersite.getRootURL() (same "current host" logic getCreditApplicationUrl()
    // used to hardcode). Unset entirely defaults to "/get-pre-approved" — the same path
    // getCreditApplicationUrl() always pointed to — so an FCA/LenderDesk site only
    // needs startApplicationButtonEnabled=true to fully restore old behavior, with zero
    // per-site URL backfill required.
    getStartApplicationButtonUrl() {
        let url = this.app.siteSettings.startApplicationButtonUrl || "/get-pre-approved";
        if (/^https?:\/\//i.test(url)) return url;
        return this.app.pmdrs.pmDealersite.getURL(url);
    }

    // Was a hardcoded href="#" (dead link) — now settings-driven, same as every other
    // per-site value here. Left as "#" (a no-op click) when unset, rather than hiding
    // the link outright, so a site that hasn't configured this yet sees the same
    // behavior as before this change, not a suddenly-missing link.
    setPrivacyPolicyLink() {
        let link = document.querySelector(this.getSelector('.privacy-policy-link'));
        if (link && this.app.siteSettings.privacyPolicyUrl) {
            link.href = this.app.siteSettings.privacyPolicyUrl;
        }
    }

    setMaxCashDownInput(){
        let cashDownInput = this.getCashDownInput();
        let msrp = this.app.getVehicleRetailPrice();

        if (cashDownInput) {
            cashDownInput.max = String(msrp);

            cashDownInput.addEventListener("input", () => {
                if (+cashDownInput.value > msrp) {
                    cashDownInput.value = msrp; // clamp to max
                }
            });
        }
    }

    hideTaxesSection(){
        if(this.disableTaxesSection){
            DOMHelper.addClass(this.getSelector('.estimated-taxes-section'), 'd-none');
            DOMHelper.addClass(this.getSelector('.taxes-section'), 'd-none');
        }
    }

    validateDoNotIncludeTaxes() {
        let siteSettings = this.app.siteSettings;
        let taxesSection = null;
        if (siteSettings.dontIncludeTaxes) {
            if (this.app.pmdrs.dataDriver.isPixelmotion()) {
                taxesSection = this.getSelector(".contact-form-group.only-pm-driver");
            } else {
                taxesSection = this.getSelector(".taxes-section.only-allcarusa-driver");
            }
        }
        if (taxesSection) {
            DOMHelper.addClass(taxesSection, "d-none");
        }
    }

    setDefaultDownPayment(){
        let dealType = this.app.dealPage.dealType;
        let cashDownInput = this.getCashDownInput();
        this.app.getInitialPayment(
            dealType,
            (paymentObject) => {
                if(!paymentObject) return 0;//skip

                const downPayment = paymentObject.downPayment;
                
                if(dealType == 'cash'){
                    DOMHelper.addClass(cashDownInput.parentElement, "dn");
                    cashDownInput.disabled = true;//disabling should remove from form submit
                    return 0;
                }else{
                    DOMHelper.removeClass(cashDownInput.parentElement, "dn");
                    cashDownInput.value = downPayment;
                    cashDownInput.disabled = false;
                    return downPayment;
                }
            },
            //on error
            (response) => {
            }
        );
    }

    // calculateDownPayment() {
    //     let dealType = this.app.dealPage.dealType;
    //     let cashDownInput = document.querySelector(this.getSelector("#payment-cashdown-value"));
    //     if (dealType != "cash") {
    //         let finalPrice = (this.app.config.vehicle.finalPrice);
    //         let isMotosAmerica = this.app.pmdrs.isMotosAmericaSite();
    //         let downPayment = 0;
    //         if (isMotosAmerica) {
    //             downPayment = Math.floor(parseFloat(finalPrice * 0.20));
    //             // downPayment = 0;
    //         } else {
    //             downPayment = 1000;
    //         }
    //         cashDownInput.value = downPayment;
    //         DOMHelper.removeClass(cashDownInput.parentElement, "dn");
    //         cashDownInput.disabled = false;
    //         return downPayment;
    //     }
    //     cashDownInput.disabled = true;//disabling should remove from form submit
    //     DOMHelper.addClass(cashDownInput.parentElement, "dn");
    //     // DOMHelper.setValue(cashDownInput,  0);//not zero to prevent weird behaviour starting by cash and the changing to the others
    //     return 0;
	// }

    setBackground(make) {
        let background = make.toLowerCase() == "indian motorcycle" ? "indian-background" : "bmw-background";
        DOMHelper.addClass(this.getTaxesBtn(), background);
        DOMHelper.addClass(document.querySelector(this.app.getSelector(".submit-button")), background);
    }

    // showHideEasyRideBox() {
    //     if (!this.app.isBMW()) {
    //         DOMHelper.addClass(document.querySelector(this.getSelector(".easy-ride-box.payment-option-box")), "dn");
    //     }
    // }


    getEasyRideInfoModal() {
        return `<div class="start-easyrideinfo-container">
    <h1 style="font-size: 2rem;">EASY RIDE BALLOON FINANCING</h1>
    <h3>EXCLUSIVELY THROUGH BMW FINANCIAL SERVICES</h3>

    <br>
    <p>We see riders on an R 12 and R 12 nineT riding in the city</p>
    <p>Financing as flexible as your destination</p>
    <p>The BMW motorcycle of your dreams may be closer than you think. BMW Financial Services is your experienced partner when it comes to financing and leasing and with our EasyRide™ financing, it’s never been easier to bring home a new BMW Motorcycle.</p>

    <br>

    <h3>THE BIKE OF YOUR DREAMS AT A PAYMENT YOU’VE BEEN DREAMING OF.</h3>
    <p>With EasyRide balloon financing, you’ll only pay a portion of the total financed amount through regular monthly payments. At the end of the term, you’ll have the flexibility to either refinance or trade in your bike to satisfy the remaining financed amount.</p>

    <p>From flexible term options and lower monthly payments to the ability to trade up your bike at the end of your contract, you can feel confident that you’re getting more bike for your buck with EasyRide from BMW Financial Services.</p>

    <ul style="list-style: circle; padding: 2rem;">
        <li>Lower monthly payments: more bike for your buck.</li>
        <li>Flexible term options: trade up to a new bike every few years.</li>
        <li>More BMW gear: finance approved ‘bolt on’ accessories.</li>
        <li>Bike trade-ups: put your current bike’s equity toward a new model.</li>
    </ul>

    <p>Contact Your Dealer For Details.</p>
</div>`;
    }

    // showHideLeaseBox() {
    //     if (this.app.isBMW() || this.app.isBMWPolaris() || this.app.isVehicleDucati() || this.app.isVehicleTriumph()
    //         || this.app.isVehicleOnlyFinance(this.app.config.vehicle.make)) {
    //         DOMHelper.addClass(document.querySelector(this.getSelector(".lease-box.payment-option-box")), "dn");
    //     }
    // }

    // showPremierBox() {
    //     if (!this.app.isVehicleDucati()) {
    //         DOMHelper.addClass(document.querySelector(this.getSelector(".premier-box.payment-option-box")), "dn");
    //     }
    // }

    // showHideTTFBox() {
    //     if (!this.app.isVehicleTriumph()) {
    //         DOMHelper.addClass(document.querySelector(this.getSelector(".ttf-box.payment-option-box")), "dn");
    //     }
    // }

    hideTradeInValueInformation() {
        let tradeInType = this.app.siteSettings.tradeInType ?? "manual";
        if (tradeInType != "manual") {
            DOMHelper.addClass(document.querySelector(this.getSelector(".trade-in-value-field")), "d-none");
        }
    }
    

    getHtml() {
        return `<div class="trigger-element" data-index="3"></div>
	<div class="your-payment-section deal-page-section" id="your-payment-section">		
		<div class="your-payment-title">Estimated Payment</div>
		<div class="your-payment-subtitle">Select your payment option</div>
		
		<div class="balloon-box payment-option-box" data-type='balloon'>
			<div class="pmdrs-loading-wrapper balloon-loading"><div class="lds-dual-ring"></div></div>
			<div class="click-curtain" name="balloon"></div>
			<div class="balloon-box-title">Easy Ride Finance</div>
			<div class="balloon-box-value">$--/mo.</div>
			<div class="box-error-msg dn"></div>			
			<div class="balloon-box-description"></div>
			<div class="balloon-links">
				<a class="balloon-learnmore-btn" target="_blank">Learn more</a> | 
				<a class="balloon-disclaimer-btn">Disclaimer</a>
			</div>
			<div class="balloon-disclaimer" style="display: none;">Estimated payments exclude applicable taxes, title, registration, license, and documentary fees, and will vary depending upon the final price and terms agreed upon between you and your Dealer.</div>
			<div class="balloon-box-termlabel">Select your term</div>
			<select name="monthlyTermField"  class="retailing-term-balloon-select" data-valuetype="term">
			</select>
		</div>

		<div class="finance-box payment-option-box" data-type='finance'>
			<div class="pmdrs-loading-wrapper finance-loading"><div class="lds-dual-ring"></div></div>
			<div class="click-curtain" name="finance"></div>
			<div class="finance-box-title">Estimated Conventional Finance</div>
			<div class="finance-box-value">$--/mo.</div>
			<div class="box-error-msg dn"></div>
			<div class="finance-box-description"> </div>			 
			<div class="finance-links">
				<a class="finance-disclaimer-btn">Disclaimer</a>
			</div>
			<div class="finance-box-label-container">
				<div class="finance-box-termlabel">Select your term</div>
				<select name="monthlyTermField" class="retailing-term-select" data-valuetype="term">
				</select>
			</div>
			<div class="only-allcarusa-driver dn">
				<div class="box-label">Financial Institutions</div>
				<select name="lenderField" class="finance-lender-select" data-valuetype="lender">
				</select>
			</div>
		</div>

		<div class="lease-box payment-option-box" data-type='lease'>
			<div class="pmdrs-loading-wrapper lease-loading"><div class="lds-dual-ring"></div></div>
			<div class="click-curtain" name="lease"></div>
			<div class="lease-box-title">Lease</div>
			<div class="lease-box-value">$--/mo.</div>
			<div class="box-error-msg dn"></div>
			<div class="lease-box-description"> </div>			 
			<div class="lease-links">
				<a class="lease-disclaimer-btn">Disclaimer</a>
			</div>
			<div class="lease-box-label-container">
				<div class="lease-box-mpylabel">Annual Milleage</div>
				<select name="mpyField" class="retailing-mpy-lease-select" data-valuetype="mileage">
				</select>
			</div>
			<div class="lease-box-label-container">
				<div class="lease-box-termlabel">Select your term</div>
				<select name="monthlyTermField" class="retailing-term-lease-select" data-valuetype="term">
				</select>
			</div>
			<div class="only-allcarusa-driver dn">
				<div class="box-label">Financial Institutions</div>
				<select name="lenderField" class="lease-lender-select" data-valuetype="lender">
				</select>
			</div>
		</div>

		<div class="cash-box payment-option-box" data-type='cash'>
			<div class="pmdrs-loading-wrapper cash-loading" style="display: none;"><div class="lds-dual-ring"></div></div>
			<div class="click-curtain" name="cash"></div>
			<div class="cash-box-title">Estimated Cash</div>
			<div class="cash-box-value"> <span class="cash-option-value">$--</span></div>
			<div class="box-error-msg dn"></div>
			<div class="cash-links">
				<a class="cash-disclaimer-btn">Disclaimer</a>
			</div>
		</div>
		<!-- START incentives -->

		<div class="pmdrs-incentives-container pmdrs-section only-allcarusa-driver">
			<div class="pmdrs-section-title">Offers</div>
			<ul class="pmdrs-incentives-list pmdrs-offers-list">
			</ul>
		 </div>

		 <div class="pmdrs-incentives-container pmdrs-section only-allcarusa-driver">
			<div class="pmdrs-section-title">Explore Conditional Offers</div>
			<ul class="pmdrs-incentives-list pmdrs-cond-offers-list">
			</ul>
		 </div>
		<!-- END Incentives -->
		<div class="start-application-button bg-blue color-white dn">Start Application <i class="pmdrs-fa pmdrs-fa-external-link"></i></div>

		<!-- <form id="payment-form" class="contact-form"> -->
		<div class="contact-form">
		    <div class="contact-form-group">
		    	<label class="contact-form-label" for="payment-cashdown">Cash Down</label>
		    	<input name="downPaymentField" id="payment-cashdown-value" class="payment-cashdown contact-form-input" type="number" />
		    </div>
		    <div class="contact-form-group">
    <label class="contact-form-label" for="payment-creditscore">Credit Score</label>
    <select class="contact-form-input retailing-credit-score-select" name="creditscoreField">
    </select>
</div>
		    <div class="contact-form-group only-pm-driver estimated-taxes-section">
		    	<label class="contact-form-label" for="payment-estimatedtax">Estimated Taxes</label>
		    	<!-- <input id="payment-estimatedtax" class="contact-form-input" type="text" /> -->
		    	<input name="postalcodeField" id="tfZipCode" class="contact-form-input" type="text" />
				<br>
				<div class="contact-form-text"></div>
				<button type="button" class="apply-taxes-button color-white">Apply</button>
		    	<p class="error-input" id="taxes-error">Please verify your zip code, taxes not applied</p>
		    </div>				    	

		    <div class="deposit-section contact-form-group down-payment-container" style="display: none">
                <div class="pmdrs-loading-wrapper down-payment-loading" style="display: none"><div class="lds-dual-ring"></div></div>

			    <div class="deposit-title">Make a Deposit</div>
		        <label class="contact-form-label" for="payment-deposit">Make a Deposit</label>
		        <select id="payment-deposit" class="contact-form-input make-a-deposit" type="text" name="makeDepositField">
		            <option value="no">No</option>
		            <option value="yes">Yes</option>
		        </select>

		        <div class="down-payment-body" style="display: none;">

                    <label for="depositAmountInput" class="contact-form-label">Deposit Amount $</label>
                    <input class="contact-form-input" type="number" min="100" name="depositField" id="depositAmountInput" value="1000" disabled>
                    <button type="button" class="apply-down-payment-button bg-blue color-white">Apply</button>

                    <p class="deposit-amount-text">Deposit amount: <span class="payment-amount-value"></span> </p><br>
                    <div id="payment-element"></div>      
                	<p class="error-input" id="make-deposit-error">Payment failed</p>
                </div>

		    </div>

	    </div>
		<!-- </form> -->
		
		<!-- miles-per-year not useful at the moment -->
        <div class="miles-per-year" style="display: none">
            <div class="contact-form-group">
    <label class="contact-form-label" for="payment-creditscore">Miles Per Year</label>
    <select class="contact-form-input retailing-miles-per-year-select" name="milesPerYearField">
    </select>
</div>
        </div>

	<div class="payment-summary-section">
		<div class="payment-summary-title">Payment Summary</div>
		<div class="vehicle-image">
			<img src="https://images.otf3.pixelmotiondemo.com/QsSVt-20230104160441.png" alt="2023 BMW G 310 GS">
		</div>
		<div class="payment-option">--</div>
		<div class="mypayment-value">$--/mo</div>
		<div class="payment-description">plus tax for <span class="mypayment-months-value">--</span> months and a single payment for $--</div>
		<!-- <div class="summary-details">
			<div class="summary-label">Summary</div>
			<div class="summary-item msrp">MSRP: $10,490</div>
			<div class="summary-item discounts d-none"></div>
        	<div class="summary-item final d-none">Final Price: </div>
			<div class="summary-item taxes d-none">Taxes: </div>
			<div class="summary-item apr">APR: <span class="deal-apr">8%</span></div>
			<div class="summary-item cashdown">Cash Down: <span class="deal-cash-down">-$1,000</span></div>
			<div class="summary-item customercash d-none">Customer Cash: <span class="customer-cash">-$1,000</span></div>
			<div class="summary-item accessories">Accessories: <span class="deal-accessories">$0.00</span></div>
			<div class="summary-item trade-in-value trade-in-value-field">Trade-In Value: <span class="deal-trade-in-value">$0.00</span></div>
			<div class="summary-item summary-item-coffers d-none">Conditional Offers: <span class="coffers-value">$0.00</span></div>
		</div> -->
		<!-- DEFAULT: Finance / Cash / Balloon -->
<div class="summary-details summary-details-default">
    <div class="summary-label">Summary</div>
    <!-- Populated instead of the fixed slots below when a payment carries paymentData.priceStack
         (currently PmRates sites that opt in via pm-motors-api, e.g. lampedodge) -->
    <div class="summary-item price-stack d-none"></div>
    <div class="summary-item msrp"><span class="summary-item-label">MSRP:</span> <span class="msrp-value">$--</span></div>
    <div class="summary-item discounts d-none"></div>
    <div class="summary-item dealer-markups d-none"></div>
    <div class="summary-item summary-item-incentives d-none"><span class="summary-item-label">Incentives:</span> <span class="summary-item-value">-<span class="incentives-value">$--</span></span></div>
    <div class="summary-item taxes d-none">Taxes: </div>
    <div class="summary-item net-price d-none"><span class="summary-item-label">Net Price:</span> <span class="net-price-value">$--</span></div>
    <div class="summary-item cashdown"><span class="summary-item-label">Cash Down:</span> <span class="deal-cash-down">-$--</span></div>
    <div class="summary-item customercash d-none"><span class="summary-item-label">Customer Cash:</span> <span class="customer-cash">-$--</span></div>
    <div class="summary-item accessories d-none"><span class="summary-item-label">Accessories:</span> <span class="mypayment-accesories-value"></span></div>
    <div class="summary-item trade-in-value trade-in-value-field d-none"><span class="summary-item-label">Trade-In Value:</span> <span class="mypayment-trade-in-value">$--</span></div>
    <div class="summary-item summary-item-coffers d-none"><span class="summary-item-label">Conditional Offers:</span> <span class="summary-item-value">-<span class="coffers-value">$--</span></span></div>
    <!-- Shown before Final Price/Amount Financed since it's now folded into that total (a
         mandatory fee, not an optional add-on) — matches the dealer's own price stack, which
         lists Doc/EFF/PTA fee before its "Best Price" line for the same reason. -->
    <div class="summary-item finance-doc-fee d-none"><span class="finance-doc-fee-label">Doc Fee:</span> <span class="finance-doc-fee-value">$--</span></div>
    <div class="summary-item final"><span class="summary-item-label final-label">Final Price:</span> <span class="final-price-value"></span></div>
    <div class="summary-item apr"><span class="summary-item-label">APR:</span> <span class="deal-apr">8%</span></div>
    <div class="summary-item finance-gov-fees d-none"><span class="summary-item-label">Government Fees:</span> <span class="finance-gov-fees-value">$--</span></div>
</div>

<!-- LEASE -->
<div class="summary-details summary-details-lease d-none">
    <div class="summary-group summary-group-monthly-payment">
        <div class="summary-group-label">Monthly Payment</div>
        <div class="summary-item lease-base-payment"><span class="summary-item-label">Base Payment:</span> <span class="lease-base-payment-value">$--</span></div>
        <div class="summary-item lease-monthly-taxes d-none"><span class="summary-item-label">Monthly Fees and Taxes:</span> <span class="lease-monthly-taxes-value">$--</span></div>
        <div class="summary-item lease-total-monthly d-none"><span class="summary-item-label">Total Monthly Payment:</span> <span class="lease-total-monthly-value">$--</span></div>
    </div>

    <div class="summary-group summary-group-due-signing">
        <div class="summary-group-label">Due at Signing</div>
        <div class="summary-item lease-cashdown"><span class="summary-item-label">Cash Down:</span> <span class="lease-cashdown-value">$--</span></div>
        <div class="summary-item lease-trade-in d-none"><span class="summary-item-label">Trade In:</span> <span class="lease-trade-in-value">$--</span></div>
        <div class="summary-item lease-trade-in-owed d-none"><span class="summary-item-label">Trade-in balance owed:</span> <span class="summary-item-value">(<span class="lease-trade-in-owed-value">$--</span>)</span></div>
        <div class="summary-item lease-doc-fee d-none"><span class="lease-doc-fee-label">Doc Fee:</span> <span class="lease-doc-fee-value">$--</span></div>
        <div class="summary-item lease-taxes d-none"><span class="summary-item-label">Taxes:</span> <span class="lease-taxes-value">$--</span></div>
        <div class="summary-item lease-gov-fees d-none"><span class="summary-item-label">Government Fees:</span> <span class="lease-gov-fees-value">$--</span></div>
        <div class="summary-item lease-total-due"><span class="summary-item-label">Total Due at Signing:</span> <span class="lease-total-due-value">$--</span></div>
    </div>
</div>

		<!-- start taxes -->
		<div class="taxes-section only-allcarusa-driver">
			<div class="pmdrs-fees-details d-none is-collapsed">
				<label class="fees-details-toggle">Detailed Fees and Taxes <span class="fees-toggle-icon">&#9660;</span></label>
				<ul></ul>
			</div>
			<button type="button" class="apply-taxes-button2 color-white">Add Fees & Taxes</button>
		</div>
		<!-- end taxes -->

		<div class="submit-button">Finish and Send</div>

		<div class="summary-disclaimer">
			<div class="summary-disclaimer-header">
				Disclaimer <span class="toggle-icon">+</span>
			</div>
			<div class="summary-disclaimer-content d-none">
				Estimated payments exclude applicable taxes, title, registration, license, and documentary fees, and will vary depending upon the final price and terms agreed upon between you and your Dealer.
			</div>
		</div>
        <p class="d-none acc-installation-costos-included" style="font-size: 10px !important; color: #555; margin-top: 50px;"><span>* Installation costs included.</span></p>				
		
		<p class="error-input" id="submit-button-error">Error</p>
		<div class="footer-disclaimer">By submitting your contact information, you consent to be contacted by telephone about purchasing a vehicle or obtaining vehicle financing. Clicking on the Submit button above is your electronic signature.<br><a href="#" class="privacy-policy-link" target="_blank">Privacy Policy</a></div>
		
	</div>

</div>`;
    }

    getRetailingTypeSelect(type) {
        let selector = this.app.getSelector(".retailing-" + type + "-select");
        // console.log(selector);
        return document.querySelector(selector);
    }    

    getLenderSelect(dealType){
        return document.querySelector(this.getSelector(`.${dealType}-lender-select`));
    }

    populateCreditScoreSelect() {
        let options = "";
        let select = this.getRetailingTypeSelect("credit-score");
        // let oldValue = select.value;
        let oldValue = this.getCurrentCreditScore();//this is config max
        let config = {};
        let rangeConfig = this.app.getCreditRangeConfig(this.app.dealPage.dealType);
        rangeConfig = this.app.dealPage.dealType == "lease" ? Object.values(rangeConfig) : rangeConfig;

        for (var index in rangeConfig) {
            config = rangeConfig[index];
            // console.log(config['max']);
            options +=
                "<option value='" +
                config["label"] +
                "' data-min=" +
                config["min"] +
                " data-max=" +
                config["max"] +
                ">" +
                FormatHelper.capitalizeFirstLetter(config["label"]).replaceAll("_", " ") +
                " (" +
                config["min"] +
                " - " +
                config["max"] +
                ")" +
                "</option>";
        }
        select.innerHTML = options;
        // oldValue comes from getCurrentCreditScore(), which reads selectedOption.dataset.max —
        // dataset values are always strings ("850"), while element.max here is a real number
        // (850) whenever rangeConfig is sourced from parsed JSON/the fallback array. The strict
        // === below never matched due to that type mismatch, so the user's selected credit tier
        // silently reset to the first (highest) option every time the deal type toggled — same
        // class of bug as populateTermSelect's term reset above, and compounds with it.
        const match = rangeConfig.find((element) => String(element.max) === String(oldValue));
        if (match) {
            // console.log("keep old value " + oldValue);
            select.value = match.label;
        }

    }

    populateMpySelect(){
        let mpys = this.app.getMillesPerYearForLease();
        let options = "";
        for (var i in mpys) {
            options +=`<option>` + mpys[i] +`</option>`;
        }
        this.getRetailingTypeSelect('mpy-lease').innerHTML = options;
    }

    populateLenders(){
        let lenders = this.app.siteSettings.lenders || [];
        let options = "";
        for (var i in lenders) {
            options += `<option value="${lenders[i]}">${lenders[i]}</option>`;
        }
        this.getLenderSelect('finance').innerHTML = options;
        this.getLenderSelect('lease').innerHTML = options;
    }

    setLenderSelectValue(dealType, lenderId) {
        if (!lenderId) return;
        let select = this.getLenderSelect(dealType);
        if (!select) return;
        if (!select.querySelector(`option[value="${lenderId}"]`)) {
            let opt = document.createElement('option');
            opt.value = lenderId;
            opt.text = lenderId;
            select.add(opt);
        }
        select.value = lenderId;
    }

    // populateTermSelect_old(type, dealType) {//remove this function inf no bugs with the new version
    //     let ratingAPR = [];
    //     let options = "";
    //     let apr = 0;
    //     let selectedRating = this.app.widget.getSelectedCreditRating(dealType);
    //     let select = this.getRetailingTypeSelect(type);
    //     let oldValue = select.value;

    //     switch (dealType) {
    //         case "lease":
    //             // let selectedMpy = this.app.widget.getSelectedMPY();
    //             let selectedMpy = this.getRetailingTypeSelect('mpy-lease').value;
    //             let mpyAprTable = this.app.getLeaseAprTableByMPY(selectedMpy);
    //             ratingAPR = mpyAprTable.find((element) => element.label === selectedRating);
    //             break;

    //         case "finance":
    //             ratingAPR = this.app.financeTable().find((elemet) => elemet.label === selectedRating);
    //             break;

    //         case "balloon":
    //             ratingAPR = this.app.balloonTable().ratings.find((elemet) => elemet.label === selectedRating);
    //             break;

    //         case "premier":
    //             ratingAPR = this.app.premierTable().ratings.find((element) => element.label === selectedRating);
    //             break;

    //         case "ttf":
    //             ratingAPR = this.app.ttfTable().ratings.find((element) => element.label === selectedRating);
    //             break;
    //         default:
    //             break;
    //     }
    //     if (type === "term-balloon" && this.app.isBMW()) {
    //         ratingAPR = this.app.balloonTable().ratings.find((elemet) => elemet.label === selectedRating);
    //     }

    //     for (var index in ratingAPR.terms) {
    //         apr = ratingAPR[index];
    //         options += "<option value='" + index + "'>" + this.app.loanTermDisplay(index, apr) + "</option>";
    //     }

    //     select.innerHTML = options;
    //     if (ratingAPR.terms.hasOwnProperty(oldValue)) {
    //         // console.log("keep old value " + oldValue);
    //         select.value = oldValue;
    //     }
    //     select.value = select.options[select.options.length - 1].value;
    // }

    populateTermSelect(type, dealType) {
        let optionsHtml = "";
        let apr = 0;
        let selectedRating = this.app.getDefaultCreditRatingLabel(dealType);
        let select = this.getRetailingTypeSelect(type);
        let oldValue = select.value;
        var selectedMpy = "";
        if (dealType == "lease"){                
            selectedMpy = this.getRetailingTypeSelect('mpy-lease').value;
        }
        
        let termOptions = this.app.getTermsOptions(dealType, selectedRating, selectedMpy);        

        for (var term of termOptions) {            
            optionsHtml += "<option value='" + term + "'>" + this.app.loanTermDisplay(term, null) + "</option>";
        }

        select.innerHTML = optionsHtml;
        // Restore the user's previously-selected term when it's still a valid option for the
        // new list; only fall back to the last (longest) term when it isn't. This "if" used to
        // be followed by an unconditional override that always re-selected the last option
        // regardless of oldValue, silently discarding the user's own term choice (36/72 months)
        // back to 84 every time the deal type toggled (finance/lease/cash) — confirmed live,
        // matches the "changing months responds, but it keeps going back to 84" report.
        //
        // String-normalized on both sides: oldValue (select.value) is always a string, but
        // termOptions is driver-dependent — confirmed live that LenderDeskDriver.getTermsOptions()
        // returns real numbers (36) while PixelmotionDriver's happened to already be strings, so a
        // plain .includes(oldValue) silently never matched on LenderDesk sites specifically (the
        // exact reason this needs testing across every driver, not just the one bug was found on).
        let termOptionsStr = termOptions.map(String);
        if (termOptionsStr.includes(oldValue)) {
            select.value = oldValue;
        } else if (select.options.length) {
            select.value = select.options[select.options.length - 1].value;
        }
    }

    //update boxes and the current 
    updatePricingDetail() {
        if (this.app.onlyEasyRide) this.app.dealPage.setDealType("balloon");
        let cashDown = 0;
        let paymentDataFinance = this.app.paymentData["finance"];
        let paymentDataLease = this.app.paymentData["lease"];
        let paymentDataBalloon = this.app.paymentData["balloon"];
        let creditScore = document.querySelector(".retailing-credit-score-select");
        let msrp = this.app.config.vehicle.finalPrice;
        DOMHelper.setInnerHTML(this.getSelector(".deal-msrp"), "$" + msrp);
        let monthsHeader = document.querySelector(this.getSelector(".vehicle-info-mobile .vehicle-lease-type-taxes"));

        let type = this.app.dealPage.dealType == "balloon" ? "Easy Ride" : this.app.dealPage.dealType;
        DOMHelper.setInnerHTML(this.getSelector(".vehicle-lease-type"), type);
        DOMHelper.setInnerHTML(this.getSelector(".deal-type"), type);
        let option = document.querySelector('input[name="paymentOptionsField"]:checked');
        option = option ? option.value : "finance";
        
        let vehicleData = {
            imageSrc: this.app.config.vehicle.imgUrl,
            infoPayment: document.querySelector(this.getSelector(".vehicle-price")),
            vehicleName: this.app.config.vehicle.label,
        };

        var paymentData = paymentDataFinance
        switch(this.app.dealPage.dealType){
            case 'finance':
                break;
            case 'lease':
                paymentData = paymentDataLease;
                break;
            case 'balloon':
                paymentData = paymentDataBalloon;
                break;
        }
        this.printNewValues(this.app.dealPage.dealType, paymentData);

        return;
    }

    getDescriptionText(type){
        var paymentData = this.app.paymentData[type];
        var plusTaxStr = this.isUsingTaxes() ? "" : "plus tax ";
        switch(type){
            case 'lease': 
                if(this.isLeaseValid()){
                    return `${plusTaxStr}for ${paymentData.term} months.`;
                }else{
                    return "Please change the cash down amount, credit score or term.";                    
                }
            case 'finance': 
                if(this.isFinancedValid()){
                    return `${plusTaxStr}for ${paymentData.term} months.`;
                }else{
                    return "Please change the cash down amount, credit score or term.";                    
                }
            case 'balloon': 
                if(this.isBalloonValid()){                                    
                    return `${plusTaxStr}for ${paymentData.term} months.`; 
                }else{
                    return 'Please change the cash down amount, credit score or term.';                
                }
        }
        return "";
    }

    getBoxDescriptionText(type){
        var paymentData = this.app.paymentData[type];
        switch(type){
            case 'finance': 
                // if(this.isFinancedValid()){
                //     // return paymentData.term +" months, excl. taxes and fees on approved credit after $0 dealer discount.";
                // }else{
                //     return "Please change the cash down amount, credit score or term.";                    
                // }
                return "";
            case 'balloon': 
            // case 'premier':
            // case 'ttf':
                // if(this.isBalloonValid()){                                    
                //     return paymentData.term +" months, excl. taxes and fees on approved credit after $0 dealer discount.";
                // }else{
                //     return 'Please change the cash down amount, credit score or term.';                
                // }
                return "";
        }
        return "";
    }

    // Doc/EFF/PTA fee is a mandatory cost, so it belongs in whatever number we present as "the
    // price" — priceStack payments (pilot: lampedodge PmRates quotes) already bake it into
    // purchasePrice/payment upstream, so adding it again here would double-count it (the same
    // "Doc Fee shown twice" bug already fixed once for the itemized display below).
    getDocFeeForTotal(paymentData){
        // pm-drs-api computes this (PaymentHelper::addComputedDisplayFields) for every
        // engine, every request — no client-side fallback needed.
        return paymentData.docFeeForTotal ?? 0;
    }

    getPaymentText(type){
        var paymentData = this.app.paymentData[type];
        var formatedMonthlyPayment = null;
        if(paymentData && paymentData.monthlyPayment){
            formatedMonthlyPayment = FormatHelper.currencyFormat(paymentData.monthlyPayment, 0)
        };

        switch(type){
            case 'lease':
                if(this.isLeaseValid()){
                    return formatedMonthlyPayment + "/mo.";
                }
                return "$0.00/mo.";
            case 'finance':
                if(this.isFinancedValid()){
                    return formatedMonthlyPayment + "/mo.";
                }
                return "$0.00/mo.";
            case 'balloon':
                if(this.isBalloonValid()){
                    return formatedMonthlyPayment + "/mo.";
                }
                return "$0.00/mo.";
            // case 'premier':
            //     return formatedMonthlyPayment + " /mo.";
            // case 'ttf':
            //     return formatedMonthlyPayment + " /mo.";
            case 'cash':
                if(formatedMonthlyPayment){
                    //pm-drs-api computes this total (finalPriceDisplay, monthlyPayment + doc
                    //fee) for every engine, every request — no client-side fallback needed.
                    let cashTotal = paymentData.finalPriceDisplay ?? paymentData.monthlyPayment;
                    return FormatHelper.currencyFormat(cashTotal, 0);
                }else{//SIMPLE cash value
                    if(this.isCashValid()){
                        return "$" + this.calculateCash();
                    }
                }
                return "$0.00";
        }
        return "";
    }

    getCashDownText(type){
        var paymentData = this.app.paymentData[type];
        if(!paymentData) return "";
        switch(type){
            case 'cash':
                return "$0";
            default:
                // pm-drs-api computes this (cashDownDisplay) for every engine, every
                // request — no client-side fallback needed.
                const cashDown = paymentData.cashDownDisplay ?? 0;
                return "-" + (FormatHelper.currencyFormat(cashDown, 0));
        }
    }

    getMoneyFactorText(type){
        var paymentData = this.app.paymentData[type];
        return paymentData.moneyFactor + "%";
    }

    getTradeInText(type){
        var paymentData = this.app.paymentData[type];
        switch(type){
            case 'lease':                                 
            case 'finance':                                 
            case 'balloon': 
                return "$" + paymentData.tradeIn;                
        }
        return "";
    }

    getTermText(type){
        var paymentData = this.app.paymentData[type];        
        return paymentData.term || "";
    }

    getPaymentOptionText(type, balloonType){        
        switch(type){
            case 'lease': return 'Lease';                                 
            case 'finance': return 'Estimated Finance';                                
            case 'balloon':
                if (this.app.config.vehicle.make.toLowerCase() == "harley-davidson") return 'H-D Flex Financing';
                switch(balloonType){
                    case 'premier': return 'Estimated Premier';
                    case 'ttf': return 'Triple Financing';
                    case 'easyride':
                    case 'easyridecash':
                        return 'Easy Ride Finance';
                }
                return 'Balloon';
            case 'cash':
                // Southbay DRA Changes [need asap] (2026-09-14): renamed to "Cash Purchase"
                if (this.app.isSouthbayChryslerJeepDodgeRam()) return 'Cash Purchase';
                return 'Estimated Cash';
        }
        return "";
    }


    getPaymentBoxTitle(dealType, balloonType){
        switch(dealType){
            case 'finance': return 'Estimated Conventional Finance';
            case 'lease': return 'Lease';
            case 'balloon':
                if (this.app.config.vehicle.make.toLowerCase() == "harley-davidson") return 'H-D Flex Financing';
                switch(balloonType){
                    case 'premier': return 'Extimated Premier Finance';
                    case 'ttf': return 'Estimated Triumph Triple Financing';
                    case 'easyride': return 'Easy Ride Finance';
                    case 'easyridecash':
                        return "Easy Ride Finance";
                    default: return 'Balloon'
                }        
        }        
        return dealType;
    }

    isFinancedValid(){
        var paymentData = this.app.paymentData['finance'];
        // pm-drs-api computes this threshold check (isValid) for every engine, every
        // request — no client-side fallback needed.
        return paymentData.isValid ?? true;
    }

    isLeaseValid(){
        var paymentData = this.app.paymentData['lease'];
        if(!paymentData) return false;
        return paymentData.isValid ?? true;
    }

    isBalloonValid(){
        var paymentData = this.app.paymentData['balloon'];
        return parseFloat(paymentData.monthlyPayment) > 0;
    }

    isCashValid(){        
        let originalMsrp = this.app.getVehicleRetailPrice();
        // let cashDown = this.getCashDownInput().value;
        let cashDown = 0;
        let tradeIn = 0;                        
        return tradeIn + cashDown < originalMsrp;//always true by the moment
    }

    //updating ui of selected payment option, header, summary, modal 
    updateMyPaymentValues(){
        var vehicle = this.app.config.vehicle;
        var currentType = this.app.dealPage.dealType;
        let paymentData = this.app.paymentData[currentType];
        if (!paymentData) return;
        var descriptionText = this.getDescriptionText(currentType);
        var paymentText = this.getPaymentText(currentType);
        var cashDownText = this.getCashDownText(currentType);
        var moneyFactor = this.getMoneyFactorText(currentType); 
        var term = this.getTermText(currentType);
        //option title tetxt
        var paymentOptionText = this.getPaymentOptionText(currentType, paymentData.balloonType);

        const cOffersTotal = this.getSelectedConditionalOffersTotal();//this function is only current type, evaluate to use paymentData instead, or not

        // paymentData.priceStack — exact dealer-matched price breakdown (currently a pilot on
        // lampedodge; see project plan). When present, it replaces MSRP/Discounts/Dealer
        // Markups/Incentives/Net Price below with one generic, ordered render; every other
        // site never has this field, so nothing here changes for them.
        this.renderPriceStack(paymentData);
        const hasPriceStack = Array.isArray(paymentData.priceStack) && paymentData.priceStack.length > 0;

        // Toggle summary blocks by deal type
        if (currentType === 'lease') {
            DOMHelper.addClass(this.app.getSelector('.summary-details-default'), 'd-none');
            DOMHelper.removeClass(this.app.getSelector('.summary-details-lease'), 'd-none');
        } else {
            DOMHelper.removeClass(this.app.getSelector('.summary-details-default'), 'd-none');
            DOMHelper.addClass(this.app.getSelector('.summary-details-lease'), 'd-none');
        }

        // DISCOUNTS — skipped entirely when this payment already reports its own complete,
        // reconciled rebate breakdown via paymentData.incentivesTotal (e.g. PmRates quotes,
        // formatted through LenderDeskDriver same as real LenderDesk ones). Showing the
        // vehicle-config-driven discount lines *and* the payment's own itemized incentives
        // double-counts whatever overlaps between them (confirmed on lampedodge: the legacy
        // vehicle.dealerDiscounts $5,000 line plus a $12,500 incentives line that already
        // includes that same $5,000).
        let discounts = vehicle.pricing.data.discount ?? [];
        let customerCashShownInDiscounts = false;
        if (hasPriceStack) {
            DOMHelper.addClass(this.app.getSelector(".discounts"), "d-none");
        } else if (paymentData.incentivesTotal) {
            this.setDiscountsHtml("");
        } else if(vehicle.dealerDiscounts){
            let discountsValue = FormatHelper.currencyFormat(vehicle.dealerDiscounts);
            let discountHTML = `<div class='item-summary discount'><span class="summary-item-label">Dealer Discounts:</span> <span class="summary-item-value">-${discountsValue}</span></div>`;
            this.setDiscountsHtml(discountHTML);
        } else if (discounts.cms && discounts.cms.items) {
            let discountHTML = "";
            const customerCashLabels = ['customer cash', 'bmw cash', 'bmw customer cash'];
            discounts.cms.items.forEach((discount) => {
                let labelLower = discount.label.toLowerCase();

                if (labelLower === "polaris consumer offer") {
                    if (currentType !== "cash") {
                        return;
                    }
                }

                // Skip certain customer cash discounts if payment type is finance
                if (customerCashLabels.includes(labelLower) && currentType === "finance") {
                    return; // skip this discount
                }

                if (this.app.paymentData['balloon']) {
                    let balloonType = this.app.paymentData['balloon']['balloonType'] ?? "";
                    if (customerCashLabels.includes(labelLower)) {
                        if (balloonType === "easyridecash" || currentType == "cash") {
                            discountHTML += `<div class='item-summary discount'><span class="summary-item-label">${discount.label}:</span> <span class="summary-item-value">-$${discount.value}</span></div>`;
                            customerCashShownInDiscounts = true;
                        }
                    }
                }
                else {
                    discountHTML += `<div class='item-summary discount'><span class="summary-item-label">${discount.label}:</span> <span class="summary-item-value">-$${discount.value}</span></div>`;
                    if (customerCashLabels.includes(labelLower)) {
                        customerCashShownInDiscounts = true;
                    }
                }
            });
            this.setDiscountsHtml(discountHTML);

        }
        // Net Price — the true pre-cash-down price, shown above Cash Down. "Final Price" below
        // already subtracts Cash Down, so it's relabeled "Amount Financed" for finance/balloon;
        // for cash there's no financing concept, so it stays "Final Price" and this line is
        // hidden to avoid showing the same number twice.
        //
        // Computed as financedAmount + downPayment rather than purchasePrice directly: every
        // driver's formatPaymentObject already nets rebates/incentives into financedAmount
        // (LenderDeskDriver: purchasePrice - downPayment - rebatesAmount; PixelmotionDriver:
        // passes financedAmount straight through), so adding downPayment back is the one
        // calculation that's correct regardless of what purchasePrice means for this driver —
        // it stopped being the net price once PmRates started sending MSRP+fees there instead
        // (needed so LenderDeskDriver's own rebate recompute lands on the right number).
        //
        // Doc fee is added back on top (via getDocFeeForTotal, 0 for priceStack payments) so
        // this stays reconcilable with "Amount Financed" below: Net Price - Cash Down should
        // still equal Amount Financed now that both include the fee.
        const docFeeForTotal = this.getDocFeeForTotal(paymentData);
        if (hasPriceStack) {
            // Superseded by priceStack's own final-labeled line (e.g. "Lampe Net Price").
            DOMHelper.addClass(this.app.getSelector(".net-price"), "d-none");
        } else if (currentType !== "cash") {
            // pm-drs-api computes this total (netPriceDisplay) for every engine, every
            // request — no client-side fallback needed.
            let netPrice = paymentData.netPriceDisplay ?? 0;
            DOMHelper.setInnerHTML(this.app.getSelector(".net-price-value"), FormatHelper.currencyFormat(netPrice, 0));
            DOMHelper.removeClass(this.app.getSelector(".net-price"), "d-none");
        } else {
            DOMHelper.addClass(this.app.getSelector(".net-price"), "d-none");
        }
        // Label and value set separately (not the whole line at once) so the static
        // label/value span structure survives — needed for the flex label/value layout
        // (see .summary-item-label/.summary-item CSS) to keep working after this runs.
        // Doc fee (docFeeForTotal) is folded into both branches below — it's a mandatory cost,
        // so the headline total should reflect it instead of listing it as an easy-to-miss
        // trailing line, matching how the dealer's own price stack already includes it in
        // "Best Price".
        DOMHelper.setInnerHTML(this.app.getSelector(".final-label"), currentType == "cash" ? "Final Price:" : "Amount Financed:");
        // pm-drs-api computes this total (finalPriceDisplay) for every engine, every
        // request — no client-side fallback needed.
        const finalPriceValue = paymentData.finalPriceDisplay ?? 0;
        DOMHelper.setInnerHTML(this.app.getSelector(".final-price-value"), FormatHelper.currencyFormat(finalPriceValue, 0));
        // DOMHelper.removeClass(this.app.getSelector(".final"), "d-none");
        //Markups — suppressed when it duplicates the Doc Fee value shown further down (same
        //underlying fee rendered twice, e.g. lampedodge showing "$85" for both), or entirely
        //when priceStack already shows Document Fee inline at its own labeled position.
        if(!hasPriceStack && vehicle.dealerMarkups && Number(vehicle.dealerMarkups) !== Number(paymentData.docFee || 0)){
            let markupsValue = FormatHelper.currencyFormat(vehicle.dealerMarkups);
            let markupsHtml = `<span class="summary-item-label">Dealer Markups:</span> <span class="summary-item-value">${markupsValue}</span>`;
            this.setMarkupsHtml(markupsHtml);
        } else {
            DOMHelper.addClass(this.app.getSelector(".dealer-markups"), "d-none");
        }

        let customerCash = 0;
        if (this.app.pmdrs.allowedCustomerCashDealTypes.includes(currentType)) {
            customerCash = this.app.paymentData[currentType]['customerCash'] || 0;
            if (customerCash == 0 || customerCashShownInDiscounts) {
                DOMHelper.addClass(this.app.getSelector(".customercash"), "d-none");
            } else {
                DOMHelper.removeClass(this.app.getSelector(".customercash"), "d-none");
            }
        } else {
            DOMHelper.addClass(this.app.getSelector(".customercash"), "d-none");
        }

        // CONDITIONAL OFFERS
        const cOffersSummaryItemSelector = this.app.getSelector(".summary-item-coffers");
        const cOffersValueSelector = this.app.getSelector(".coffers-value");
        if(cOffersTotal){
            DOMHelper.setInnerHTML(cOffersValueSelector, FormatHelper.currencyFormat(cOffersTotal) );
            DOMHelper.removeClass(cOffersSummaryItemSelector, "d-none");
        }else{
            DOMHelper.addClass(cOffersSummaryItemSelector, "d-none");
        }
        // attribute data-dealtype to add CSS (not a class to avoid code to switch classes)
        DOMHelper.setData(this.app.getSelector(".payment-summary-section"), "dealtype", currentType);

        DOMHelper.setInnerHTML(this.app.getSelector(".payment-option"), paymentOptionText);        
        DOMHelper.setInnerHTML(this.app.getSelector(".mypayment-label"), paymentOptionText);        
        DOMHelper.setInnerHTML(this.app.getSelector("span.apr-header"), moneyFactor);
        DOMHelper.setInnerHTML(this.app.getSelector("span.deal-apr"), moneyFactor);
        DOMHelper.setInnerHTML(this.app.getSelector(".vehicle-lease-apr"), moneyFactor);
        DOMHelper.setInnerHTML(this.app.getSelector(".mypayment-months-value"), term);
        DOMHelper.setInnerHTML(this.app.getSelector(".taxmonths"), descriptionText);
        DOMHelper.setInnerHTML(this.app.getSelector(".mypayment-value"), paymentText);
        DOMHelper.setInnerHTML(this.app.getSelector(".deal-cash-down"), cashDownText);
        DOMHelper.setInnerHTML(this.app.getSelector(".customer-cash"), "-$" + customerCash);
        DOMHelper.setInnerHTML(this.app.getSelector(".payment-description"), descriptionText);
        

        //Accessories 
        if(this.app.dealPage.accessoriesValue){
            this.setAccessoriesTotalHtml(FormatHelper.currencyFormat(this.app.dealPage.accessoriesValue));
        }else{
            DOMHelper.addClass(this.app.getSelector(".summary-item.accessories"), "d-none");
        }

        //Incentives — priceStack shows each rebate individually at its own labeled position
        //instead of one lump total.
        if(!hasPriceStack && paymentData.incentivesTotal){
            this.setIncentivesTotalHtml(FormatHelper.currencyFormat(paymentData.incentivesTotal, 0));
        }else{
            DOMHelper.addClass(this.app.getSelector(".summary-item-incentives"), "d-none");
        }
        
        //see details modal, TODO a clean code version
        //fall back to the payment object's purchasePrice when the vehicle feed has no distinct
        //MSRP/retail price (e.g. PmRates-driven dealers like Lampe Dodge/Johnson Dodge, whose
        //feed doesn't track a separate sticker price from the selling price)
        let msrp = this.app.getVehicleRetailPrice() || paymentData.purchasePrice;
        //app-scoped (not this.getSelector/.your-payment-section-scoped): rearrangeSectionsForLampedodge()
        //moves .payment-summary-section outside #your-payment-section, so a selector scoped to
        //.your-payment-section never matches it there, same as every other line in this function
        if (hasPriceStack) {
            // priceStack's own first line already shows MSRP at its dealer-labeled position.
            DOMHelper.addClass(this.app.getSelector(".msrp"), "d-none");
        } else {
            DOMHelper.removeClass(this.app.getSelector(".msrp"), "d-none");
            DOMHelper.setInnerHTML(this.app.getSelector(".msrp-value"), FormatHelper.currencyFormat(msrp, 0));
        }
        let creditScore = document.querySelector(".retailing-credit-score-select");
        // if(currentType == 'cash'){
        //     let tradeInValue = 0;
        //     paymentData = {
        //         // downPayment: this.getCashDownInput().value + tradeInValue,//trade in value
        //         downPayment: 0 + tradeInValue,
        //         tradeIn: tradeInValue,
        //     };            
        // }
        this.app.dealPage.seeDetails.updateValues(paymentData, creditScore, currentType, msrp);
        let feesAndTaxesTotal = this.getFeesAndTaxesTotal();
        //TAXES, it's a "myPayment" thing because it should show taxes by selected payment option
        if(this.isUsingTaxes()){
            this.setTaxesBtnText(feesAndTaxesTotal);//taxesValue will be removed, ideally
            this.updateFeesAndTaxesDetails(paymentData.feesAndTaxesList);
        }else{
            this.stopUsingTaxes();//it re set taxes=false but it's fine
        }

        if (currentType === 'lease') {
            this.updateLeaseSummary(paymentData);
        } else {
            const tradeIn = paymentData.tradeIn || 0;
            const tradeInField = this.app.getSelector('.trade-in-value-field');
            if (tradeIn > 0) {
                DOMHelper.setInnerHTML(this.app.getSelector('.mypayment-trade-in-value'), '-' + FormatHelper.currencyFormat(tradeIn));
                DOMHelper.removeClass(tradeInField, 'd-none');
            } else {
                DOMHelper.addClass(tradeInField, 'd-none');
            }

            // Suppressed entirely when priceStack is active — Document Fee already shows once,
            // inline, at its dealer-labeled stack position; showing it again here would
            // reintroduce the exact "Doc Fee shown twice" bug already fixed once. Uses
            // docFeeDisplay, not docFeeForTotal: LenderDesk finance quotes already carry the fee
            // inside financedAmount (docFeeForTotal 0, so it isn't added twice) but the row
            // should still show it.
            const docFeeDisplay = paymentData.docFeeDisplay ?? docFeeForTotal;
            if (docFeeDisplay > 0) {
                DOMHelper.setInnerHTML(this.app.getSelector('.finance-doc-fee-label'), this.getDocFeeLabel());
                DOMHelper.setInnerHTML(this.app.getSelector('.finance-doc-fee-value'), FormatHelper.currencyFormat(docFeeDisplay));
                DOMHelper.removeClass(this.app.getSelector('.finance-doc-fee'), 'd-none');
            } else {
                DOMHelper.addClass(this.app.getSelector('.finance-doc-fee'), 'd-none');
            }

            const govFeesTotal = paymentData.leaseGovFeesTotal || 0;
            if (this.isUsingTaxes() && govFeesTotal > 0) {
                DOMHelper.setInnerHTML(this.app.getSelector('.finance-gov-fees-value'), FormatHelper.currencyFormat(govFeesTotal));
                DOMHelper.removeClass(this.app.getSelector('.finance-gov-fees'), 'd-none');
            } else {
                DOMHelper.addClass(this.app.getSelector('.finance-gov-fees'), 'd-none');
            }
        }
    }

    getDocFeeLabel() {
        // Colon included here (not in the static template) since this always fully replaces
        // the label span's content — keeping it out of the template would leave a bare colon
        // as its own anonymous flex item, breaking the label/value space-between layout.
        switch (this.app.pmdrs.config.accountId) {
            case 'starrmotorschryslerdodgejeep':
                return 'Processing Fee:';
            default:
                return 'Doc Fee:';
        }
    }

    updateLeaseSummary(paymentData) {
        // ── Monthly Payment ──────────────────────────────────────────────────────
        // paymentBeforeTaxes = base monthly payment (no taxes); falls back to monthlyPayment
        const basePayment = paymentData.paymentBeforeTaxes || paymentData.monthlyPayment || 0;
        DOMHelper.setInnerHTML(
            this.app.getSelector('.lease-base-payment-value'),
            FormatHelper.currencyFormat(basePayment)
        );

        // Monthly taxes = total monthly payment - base payment (only when taxes applied and paymentBeforeTaxes is available)
        const monthlyTaxes = (this.isUsingTaxes() && paymentData.paymentBeforeTaxes)
            ? (paymentData.monthlyPayment || 0) - paymentData.paymentBeforeTaxes
            : 0;
        if (monthlyTaxes > 0) {
            DOMHelper.setInnerHTML(
                this.app.getSelector('.lease-monthly-taxes-value'),
                FormatHelper.currencyFormat(monthlyTaxes)
            );
            DOMHelper.removeClass(this.app.getSelector('.lease-monthly-taxes'), 'd-none');
            DOMHelper.setInnerHTML(
                this.app.getSelector('.lease-total-monthly-value'),
                FormatHelper.currencyFormat(paymentData.monthlyPayment || 0)
            );
            DOMHelper.removeClass(this.app.getSelector('.lease-total-monthly'), 'd-none');
        } else {
            DOMHelper.addClass(this.app.getSelector('.lease-monthly-taxes'), 'd-none');
            DOMHelper.addClass(this.app.getSelector('.lease-total-monthly'), 'd-none');
        }

        // ── Due at Signing ───────────────────────────────────────────────────────
        const tradeIn = paymentData.tradeIn || 0;
        const cashDown = (paymentData.downPayment || 0) - tradeIn;
        DOMHelper.setInnerHTML(
            this.app.getSelector('.lease-cashdown-value'),
            FormatHelper.currencyFormat(cashDown)
        );

        // Trade-In
        if (tradeIn > 0) {
            DOMHelper.setInnerHTML(
                this.app.getSelector('.lease-trade-in-value'),
                FormatHelper.currencyFormat(tradeIn)
            );
            DOMHelper.removeClass(this.app.getSelector('.lease-trade-in'), 'd-none');
        } else {
            DOMHelper.addClass(this.app.getSelector('.lease-trade-in'), 'd-none');
        }

        // Trade-in balance owed — TODO: wire up paymentData.tradeInBalanceOwed when available
        const tradeInBalanceOwed = paymentData.tradeInBalanceOwed || 0;
        if (tradeInBalanceOwed > 0) {
            DOMHelper.setInnerHTML(
                this.app.getSelector('.lease-trade-in-owed-value'),
                FormatHelper.currencyFormat(tradeInBalanceOwed)
            );
            DOMHelper.removeClass(this.app.getSelector('.lease-trade-in-owed'), 'd-none');
        } else {
            DOMHelper.addClass(this.app.getSelector('.lease-trade-in-owed'), 'd-none');
        }

        // Doc Fee — top-level field from LenderDesk API (shown when > 0, independent of taxes flag)
        const docFee = paymentData.docFee || 0;
        if (docFee > 0) {
            DOMHelper.setInnerHTML(
                this.app.getSelector('.lease-doc-fee-label'),
                this.getDocFeeLabel()
            );
            DOMHelper.setInnerHTML(
                this.app.getSelector('.lease-doc-fee-value'),
                FormatHelper.currencyFormat(docFee)
            );
            DOMHelper.removeClass(this.app.getSelector('.lease-doc-fee'), 'd-none');
        } else {
            DOMHelper.addClass(this.app.getSelector('.lease-doc-fee'), 'd-none');
        }

        // Taxes — sum of feeDetails where feeType === 'Sales'
        const leaseTaxesTotal = paymentData.leaseTaxesTotal || 0;
        if (this.isUsingTaxes() && leaseTaxesTotal > 0) {
            DOMHelper.setInnerHTML(
                this.app.getSelector('.lease-taxes-value'),
                FormatHelper.currencyFormat(leaseTaxesTotal)
            );
            DOMHelper.removeClass(this.app.getSelector('.lease-taxes'), 'd-none');
        } else {
            DOMHelper.addClass(this.app.getSelector('.lease-taxes'), 'd-none');
        }

        // Government Fees — sum of feeDetails where feeType === 'Registration'
        const leaseGovFeesTotal = paymentData.leaseGovFeesTotal || 0;
        if (this.isUsingTaxes() && leaseGovFeesTotal > 0) {
            DOMHelper.setInnerHTML(
                this.app.getSelector('.lease-gov-fees-value'),
                FormatHelper.currencyFormat(leaseGovFeesTotal)
            );
            DOMHelper.removeClass(this.app.getSelector('.lease-gov-fees'), 'd-none');
        } else {
            DOMHelper.addClass(this.app.getSelector('.lease-gov-fees'), 'd-none');
        }

        // Total Due at Signing — NOT dueAtSign from the API (down + first month); pm-drs-api
        // computes both variants (dueAtSignBase/dueAtSignWithTaxes) for every engine, every
        // request — read the one matching the current taxes toggle, no client-side fallback.
        let totalDue = this.isUsingTaxes() ? (paymentData.dueAtSignWithTaxes ?? 0) : (paymentData.dueAtSignBase ?? 0);
        DOMHelper.setInnerHTML(
            this.app.getSelector('.lease-total-due-value'),
            FormatHelper.currencyFormat(totalDue)
        );
    }

    setDiscountsHtml(discountHTML){
        DOMHelper.setInnerHTML(this.app.getSelector(".discounts"), discountHTML);
        DOMHelper.removeClass(this.app.getSelector(".discounts"), "d-none");
    }

    setMarkupsHtml(markupsHtml){
        DOMHelper.setInnerHTML(this.app.getSelector(".dealer-markups"), markupsHtml);
        DOMHelper.removeClass(this.app.getSelector(".dealer-markups"), "d-none");
    }

    setAccessoriesTotalHtml(accessoriesHtml){
        DOMHelper.setInnerHTML(this.getSelector(".mypayment-accesories-value"), accessoriesHtml);
        DOMHelper.removeClass(this.app.getSelector(".summary-item.accessories"), "d-none");
    }

    setIncentivesTotalHtml(incentivesHtml){
        DOMHelper.setInnerHTML(this.app.getSelector(".incentives-value"), incentivesHtml);
        DOMHelper.removeClass(this.app.getSelector(".summary-item-incentives"), "d-none");
    }

    // Renders paymentData.priceStack — an ordered {key, label, amount, type} list built
    // server-side (PmRates::buildPriceStack) matching a dealer's own price-stack labels/order
    // (PmRates dealers only: lampedodge, southbay, and any other site whose pm-motors-api
    // template exposes priceStackLabels). Every amount is a raw number; this is the only
    // place that decides how it's formatted/signed, same responsibility this component
    // already has for every other value on the page — no formatting happens server-side.
    // 'info' type (e.g. "Total Savings") renders with no sign, same as 'base'/'final'.
    // 'divider' type has no label/amount — it reproduces a rule a dealer's own template drew
    // above a specific row via inline style (see priceStackRows/dividerBefore in pm-motors-api)
    // rather than a plain label:value line.
    // Empty/absent priceStack hides the container and changes nothing else.
    renderPriceStack(paymentData){
        const container = this.app.getSelector(".price-stack");
        const stack = paymentData.priceStack;
        if (!Array.isArray(stack) || !stack.length) {
            DOMHelper.addClass(container, "d-none");
            DOMHelper.setInnerHTML(container, "");
            return;
        }
        const signFor = (type) => type === "subtract" ? "-" : (type === "add" ? "+" : "");
        const html = stack.map(item =>
            item.type === "divider"
                ? `<div class="price-stack-item price-stack-divider"></div>`
                : `<div class="item-summary price-stack-item price-stack-${item.type}"><span class="summary-item-label">${item.label}:</span> <span class="summary-item-value">${signFor(item.type)}${FormatHelper.currencyFormat(item.amount, 0)}</span></div>`
        ).join("");
        DOMHelper.setInnerHTML(container, html);
        DOMHelper.removeClass(container, "d-none");
    }

    getFeesAndTaxesTotal(){//to give priority to paymentData taxes total, so eventually we can remove the taxesValue attribute
        var currentType = this.app.dealPage.dealType;
        let paymentData = this.app.paymentData[currentType];
        return paymentData.feesAndTaxesTotal || this.taxesValue * this.app.config.vehicle.finalPrice;
    }

    updateFinanceBox(){
        var paymentData = this.app.paymentData["finance"];        
        if(!paymentData) return;//skip no data

        var paymentText = this.getPaymentText('finance');
        var cashDownText = this.getCashDownText('finance');
        var tradeInText = this.getTradeInText('finance');
        var descriptionText = this.getBoxDescriptionText('finance');

        DOMHelper.setInnerHTML(this.getSelector(".finance-box-value"), paymentText);
        DOMHelper.setInnerHTML(this.getSelector(".finance-box-description"), descriptionText);
        DOMHelper.setInnerHTML(this.getSelector(".downpayment-header"), cashDownText);
        DOMHelper.setInnerHTML(this.getSelector(".trade-in-header"), tradeInText);
        DOMHelper.setInnerHTML(this.getSelector(".deal-trade-in-value"), tradeInText);
        this.setLenderSelectValue('finance', paymentData.lenderId);
        this.getRetailingTypeSelect('term').value = paymentData.term;
    }

    updateLeaseBox(){
        var paymentData = this.app.paymentData["lease"];   
        if(!paymentData) return;//skip no data

        var paymentText = this.getPaymentText('lease');
        var cashDownText = this.getCashDownText('lease');
        var tradeInText = this.getTradeInText('lease');
        var descriptionText = this.getBoxDescriptionText('lease');

        DOMHelper.setInnerHTML(this.getSelector(".lease-box-value"), paymentText);
        DOMHelper.setInnerHTML(this.getSelector(".lease-box-description"), descriptionText);
        DOMHelper.setInnerHTML(this.getSelector(".downpayment-header"), cashDownText);
        DOMHelper.setInnerHTML(this.getSelector(".trade-in-header"), tradeInText);
        DOMHelper.setInnerHTML(this.getSelector(".deal-trade-in-value"), tradeInText);
        this.setLenderSelectValue('lease', paymentData.lenderId);
        this.getRetailingTypeSelect('term-lease').value = paymentData.term;
    }

    updateBalloonBox(){      
        var paymentData = this.app.paymentData["balloon"];   
        if(!paymentData) return;//skip no data

        var paymentText = this.getPaymentText('balloon');
        var boxTitle = this.getPaymentBoxTitle('balloon', paymentData.balloonType);
        var term = this.getTermText('balloon');
        var descriptionText = this.getBoxDescriptionText('balloon');
        DOMHelper.setInnerHTML(this.getSelector(".balloon-box-title"),boxTitle);
        DOMHelper.setInnerHTML(this.getSelector(".balloon-box-value"),paymentText);
        DOMHelper.setInnerHTML(this.getSelector(".balloon-box-months-value"), term);
        DOMHelper.setInnerHTML(this.getSelector(".balloon-box-description"), descriptionText);
    }

    updateEasyRideBox(){      
        var paymentData = this.app.paymentData["balloon"];   
        if(!paymentData) return;//skip no data

        var paymentText = this.getPaymentText('balloon');
        var term = this.getTermText('balloon');
        var descriptionText = this.getBoxDescriptionText('balloon');
        DOMHelper.setInnerHTML(this.getSelector(".easy-ride-box-value"),paymentText);
        DOMHelper.setInnerHTML(this.getSelector(".easy-ride-box-months-value"), term);
        DOMHelper.setInnerHTML(this.getSelector(".easy-ride-box-description"), descriptionText);
    }

    // updatePremierBox() {
    //     var paymentData = this.app.paymentData["premier"];   
    //     if(!paymentData) return;//skip no data

    //     var paymentText = this.getPaymentText('premier');
    //     var term = this.getTermText('premier');
    //     var descriptionText = this.getBoxDescriptionText('balloon');
    //     DOMHelper.setInnerHTML(this.getSelector(".premier-box-value"),paymentText);
    //     DOMHelper.setInnerHTML(this.getSelector(".premier-box-months-value"), term);
    //     DOMHelper.setInnerHTML(this.getSelector(".premier-box-description"), descriptionText);
    // }

    // updateTTFBox() {
    //     var paymentData = this.app.paymentData["ttf"];   
    //     if(!paymentData) return;//skip no data

    //     var paymentText = this.getPaymentText('ttf');
    //     var term = this.getTermText('ttf');
    //     var descriptionText = this.getBoxDescriptionText('balloon');
    //     DOMHelper.setInnerHTML(this.getSelector(".ttf-box-value"),paymentText);
    //     DOMHelper.setInnerHTML(this.getSelector(".ttf-box-months-value"), term);
    //     DOMHelper.setInnerHTML(this.getSelector(".ttf-box-description"), descriptionText);
    // }

    updateCashBox(){            
        var paymentText = this.getPaymentText('cash');        
        let cashOptionValue = document.querySelector(this.getSelector(".cash-option-value"));
        let cashOptionColor = "black";
        if (!this.isCashValid()){
            cashOptionColor = "red";        
        }
        cashOptionValue.innerHTML = paymentText;
        cashOptionValue.style.color = cashOptionColor;
    }

    updatePaymentBox(type){
        switch(type){
            case 'lease': this.updateLeaseBox(); break;
            case 'finance': this.updateFinanceBox(); break;
            case 'balloon': this.updateBalloonBox(); break;
            case 'cash': this.updateCashBox(); break;
            // case 'premier': this.updatePremierBox(); break;
            // case 'ttf': this.updateTTFBox(); break;
        }
    }

    printNewValues(type, paymentData) {
        let cashDown = 0;
        switch (type) {
            case "finance":
                DOMHelper.setInnerHTML(this.app.getSelector(".payment-option"), "Finance");            
                //global values                    
                this.updateMyPaymentValues()

                //box values                    
                this.updateFinanceBox();                
                break;

            case "balloon":
                DOMHelper.setInnerHTML(this.app.getSelector(".payment-option"), "Easy Ride");                            
                //global values
                this.updateMyPaymentValues()
                //box values                                        
                this.updateBalloonBox();
                // this.updateEasyRideBox();
                 
                break;

            // case "premier":
            //     DOMHelper.setInnerHTML(this.app.getSelector(".payment-option"), "Premier Tier");                            
            //     //global values
            //     this.updateMyPaymentValues()
            //     //box values                                        
            //     this.updatePremierBox();
            //     break;

            // case "ttf":
            //     DOMHelper.setInnerHTML(this.app.getSelector(".payment-option"), "Premier Tier");
            //     //global values
            //     this.updateMyPaymentValues();
            //     //box values                                        
            //     this.updateTTFBox();
            //     break;

            case "lease":
                DOMHelper.setInnerHTML(this.app.getSelector(".payment-option"), "Lease");
                //global values
                this.updateMyPaymentValues()
                //box values
                this.updateLeaseBox();
                break;
            default:
                break;
        }
    }

    calculateCash() {
        let msrp = this.app.config.vehicle.finalPrice;
        // let accessoriesSelected = document.querySelectorAll(".accessory-selected");
        // let accPrice = accessoriesSelected.length == 0 ? 0 : this.app.dealPage.accessoriesValue;
        let payment = this.app.paymentData['cash']['payment'] || 0;

        msrp = payment;
        msrp = Math.round(msrp);
        msrp = msrp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return msrp;
    }

    getCashDownInput(){
        return document.querySelector(this.app.getSelector('.payment-cashdown'));
    }

    updateCashValue() {
        let originalMsrp = this.app.getVehicleRetailPrice();
        // let cashDown = this.getCashDownInput().value;
        let cashDown = 0;
        let tradeIn = 0;
        let cashText = "$0.00";
        let cashOptionValue = document.querySelector(this.getSelector(".cash-option-value"));
        let cashOptionColor = "black";
        
        if (tradeIn + cashDown < originalMsrp) {
            cashText = "$" + this.calculateCash();
        } else {
            cashOptionColor = "red";
        }

        DOMHelper.setInnerHTML(this.getSelector(".deal-accessories"), "$" + this.app.dealPage.accessoriesValue.toFixed(2));
        
        //global values
        DOMHelper.setInnerHTML(this.app.getSelector(".payment-option"), "Cash");        
        DOMHelper.setInnerHTML(this.app.getSelector(".mypayment-value"), cashText);
        DOMHelper.setInnerHTML(this.app.getSelector(".taxmonths"),"");
        
        //box values
        cashOptionValue.innerHTML = cashText;
        cashOptionValue.style.color = cashOptionColor;
        DOMHelper.setInnerHTML(this.getSelector(".payment-description"),"");

    }

    getCurrentCreditScore(){//returns integer beacon, ex. 850
        let select = this.getRetailingTypeSelect("credit-score");
        let selectedOption = select.options[select.selectedIndex];
        if(selectedOption){
            return selectedOption.dataset.max || 0;
        }
        return 0;
    }

    getCurrentCreditScoreRangeStr(){//returns string ex 700 - 850
        var currentType = this.app.dealPage.dealType;
        if (currentType == "cash") return 0;
        let select = this.getRetailingTypeSelect("credit-score");
        let selectedOption = select.options[select.selectedIndex];
        return selectedOption.dataset.min + " - " + selectedOption.dataset.max;
    }


    getPaymentParams(type) {
        // let ratingKey = null;
        // if (type == "premier") {
        //     ratingKey = this.app.widget.getSelectedCreditRating("premier");
        // } else {
        //     ratingKey = this.getRetailingTypeSelect("credit-score").value;
        // }
        // let ratingInteger = this.app.widget.ratingKeyToInteger(type, ratingKey);
        let ratingKey = this.getRetailingTypeSelect("credit-score").value;
        let ratingInteger = this.getCurrentCreditScore();
        let months = 0;
        switch (type) {
            case "balloon":
                months = this.getRetailingTypeSelect("term-balloon").value;
                break;

            case "finance":
                months = this.getRetailingTypeSelect("term").value;
                break;

            case "lease":
                months = this.getRetailingTypeSelect("term-lease").value;
                break;

            // case "premier":
            //     months = this.getRetailingTypeSelect("term-premier").value;
            //     break;

            // case "ttf":
            //     months = this.getRetailingTypeSelect("term-ttf").value;
            //     break;
            default:
                break;
        }
        // let cashDown = this.downPaymentSlider.getValue();//waiting if the new ui will need it
        let cashDown = parseFloat(document.querySelector(this.getSelector('.payment-cashdown')).value) || 0;
        if (!this.app.dealPage.tradeInSection?.includeTradeIn) {
            this.tradeInData.tradeInEstimate = 0;
        }
        let mileageAllowance = 0;
        var lenderId = null;
        switch (type) {
            case "finance":
                lenderId = this.getLenderSelect(type).value;
                break;

            case "lease":
                mileageAllowance = this.getRetailingTypeSelect('mpy-lease').value;
                lenderId = this.getLenderSelect(type).value;
                break;
        }

        let paymentData = {//this is params to get paymentObject
            cashDown: cashDown,
            creditRating: ratingInteger,
            creditRatingKey: ratingKey,
            loanMonths: months,
            tradeInData: this.tradeInData,
            mileageAllowance: mileageAllowance,
            accessoriesPrice: this.app.dealPage.accessoriesValue,
            // Array of programIds — PmRatesController does its own sum server-side from this
            // (see signal-based-rebate-selection-plan.md). But LenderDeskController explicitly
            // strips SelectedRebateIds before forwarding to the real external vendor (it's
            // consumed only by PmRates) — for a genuine LenderDesk site, nothing server-side
            // ever applies a selected conditional offer to the price. LenderDeskDriver.
            // getRequestParams() still does its own client-side subtraction for that case
            // (selectedConditionalTotal, looked up from paymentData.conditionalOffers), so that
            // lookup table has to travel alongside the ids below — without it, every lookup
            // silently misses and the selection never changes the quoted payment (regression:
            // this field was dropped when conditionalOffersTotal was replaced by selectedRebateIds).
            selectedRebateIds: Object.keys(this.getSelectedConditionalOffers()),
            conditionalOffers: this.getSelectedConditionalOffers(),
            lenderId: lenderId,
            balloonType: this.app.paymentData[type]?.balloonType || "",//created to keep easyridecash after payment requests
            // customerCash: this.getCustomerCash(type),//I think it's no need since we have easyridecash balloontype and cCash doesn't change
            // this.app.dealPage.paymentSection
            taxesByZipCode: this.taxesValue,
            customerZipCode: this.app.dealPage.contactFormSection.getCustomerZipCode(),
        };

        // if (type == "premier") {
        //     console.log("GET PAYMENT PARAMS PAYMENT SECTION");
        //     console.log(paymentData);
        // }
        return paymentData;
    }

    // getCustomerCash(type) {
    //     let customerCash = 0;
    //     if (this.app.pmdrs.allowedCustomerCashDealTypes.includes(type)) {
    //         customerCash = this.app.paymentData[type].customerCash;
    //     }

    //     return customerCash;
    // }

    async processPayment(successCallback) {
        this.hideMakeDepositError();
        this.hideSubmitButtonError();

        let emailElem = document.querySelector(this.app.dealPage.contactFormSection.getSelector(".ciEmail"));
        this.app.dealPage.showLoading();
        this.disableSubmitBtn();
        var stripeElements = this.stripeElements;
        var emailAddress = emailElem.value;
        var domain = window.location.origin;
        domain = domain == 'file://' ? 'https://dra.dev.pixelmotiondemo.com' : domain; 
        const { error, paymentIntent } = await this.stripe.confirmPayment({
            elements: stripeElements,
            confirmParams: {
                return_url: domain + "/thank-you", //we're not redirecting but a TY will be the default behaviour
                receipt_email: emailAddress,
                payment_method_data: {
                    billing_details: {
                        address: {
                            country: "US",
                        },
                    },
                },
            },
            redirect: "if_required", //to not redirect automatically
        });

        this.app.dealPage.hideLoading();
        if (error) {
            if(!['incomplete_number', 'incomplete_cvc', 'incomplete_expiry'].includes(error.code)){
                this.showMakeDepositError(error.message);            
            }
            this.showSubmitButtonError(error.message);            
            // this.enableSubmitBtn();
            console.error(error);
            // handleError();
        } else if (paymentIntent && paymentIntent.status === "succeeded") {
            console.log("Payment succeeded, receipt_email: " + emailAddress);
            successCallback(paymentIntent);
            // handleSuccess();
        } else {
            console.log("Payment failed");
            // handleOther();
        }
    }


    updateMonthlyPayment(type, paymentData, trigger = 'recalculation') {
        let $this = this;
        paymentData = paymentData || this.getPaymentParams(type);
        //LOADDING AND DISABLE
        this.hideUnablePaymentMessage(type);
        this.hideMyPaymentError(type);
        this.showLoading(type);
        this.app.dealPage.showLoading();
        this.app.dealPage.showHeaderLoading();
        this.disableConditionalOffers();
        this.disableTaxesBtn();

        //RESEST LOADING AND DISABLE
        const resetLoadings = () => {
            $this.hideLoading(type);
            $this.app.dealPage.hideHeaderLoading();
            $this.app.dealPage.hideLoading();
            $this.enableConditionalOffers();
            $this.enableTaxesBtn();
        }

        this.app.getPayment(
            this.isUsingTaxes(),//boolean
            type,
            paymentData,
            (paymentObject) => {
                resetLoadings();

                if (!paymentObject) {
                    this.showUnablePaymentMessage(type);
                    this.showMyPaymentError(type);
                    return;
                }
                if (paymentObject && paymentObject.financedAmount < this.app.getMinimumAmountFinanced() || paymentObject.monthlyPayment < 0) {
                    let message = "Downpayment + Trade-in value is higher than the financing cost of the vehicle. You may be eligible to receive an amount from the dealer. Your dealer will confirm the final pricing based on the incentives, discounts, trade-in value and taxes & fees";
                    this.showUnablePaymentMessage(type, message);
                    this.showMyPaymentError(type);
                    return;
                }

                // DOMHelper.setInnerHTML(".deal-page-error-msg", "");
                paymentObject.tradeIn = paymentData.tradeInData.tradeInEstimate || 0;
                this.app.setPaymentData(type, paymentObject);
                this.updatePaymentBox(type);
                this.updateMyPaymentValues();
                this.updateCondOffersList();
                this.updateOffersList();
                this.trackPaymentRecalculated(type, paymentObject, trigger);
                // console.log(this.app.paymentData);
            },
            (response) => {
                resetLoadings();
                this.showUnablePaymentMessage(type);
                this.showMyPaymentError(type);
                // response = JSON.parse(response);
                // console.log(response);
                // let msg = response.Message;
                // if (response.ErrorCode == 0) {}
            }
        );
    }

    // vehicle snapshot shape matches the one already attached to submitEvent calls (see
    // DealPage.js), so pm-customers can correlate this event to the same vehicle across event
    // types in a multi-vehicle session.
    getVehicleSnapshot(){
        let vehicle = this.app.config.vehicle;
        return {
            vin: vehicle.vin,
            condition: vehicle.condition,
            year: vehicle.year,
            make: vehicle.make,
            model: vehicle.model,
            trim: vehicle.trim,
        };
    }

    // Fires the paymentRecalculated tracking event with the values actually just displayed for
    // this deal type - monthlyPayment/apr/term come straight from the payment object that was
    // just written to this.app.paymentData and rendered, not recomputed here. Deduped per deal
    // type against the last fired snapshot so a re-render loop producing the same exact result
    // doesn't post it more than once.
    trackPaymentRecalculated(type, paymentData, trigger){
        if(!paymentData) return;

        const monthlyPayment = Number(paymentData.monthlyPayment) || 0;
        const monthlyTaxes = (this.isUsingTaxes() && paymentData.paymentBeforeTaxes)
            ? monthlyPayment - Number(paymentData.paymentBeforeTaxes)
            : 0;
        const apr = (paymentData.moneyFactor ?? "") + "%";
        const termMonths = Number(paymentData.term) || 0;
        const downPayment = Number(paymentData.downPayment) || 0;

        const snapshot = JSON.stringify({ termMonths, downPayment, monthlyPayment, monthlyTaxes, apr });
        if (this.lastRecalcSnapshot[type] === snapshot) return;
        this.lastRecalcSnapshot[type] = snapshot;

        this.app.pmDRSDatalayer.paymentRecalculatedEvent(
            PmDRSDatalayer.PAYMENT_SECTION,
            {
                paymentType: type,
                termMonths,
                downPayment,
                monthlyPayment,
                monthlyTaxes,
                apr,
                trigger,
            },
            this.getVehicleSnapshot()
        );
    }

    /** paymentObject format defined in data driver */
    displayCurrentPayments(){
        this.app.pmdrs.allDealTypes.forEach(dealType => {
            if(this.app.paymentData[dealType]){
                this.updatePaymentBox(dealType);
                this.hideLoading(dealType);
                this.trackPaymentRecalculated(dealType, this.app.paymentData[dealType], 'initial_display');
            }else{//if no payment data
                DOMHelper.addClass(document.querySelector(this.getSelector(`.${dealType}-box.payment-option-box`)), "dn");
            }

        });

        this.app.dealPage.hideHeaderLoading();
        this.updateMyPaymentValues();
        this.updateCondOffersList();
        this.updateOffersList();
    }

    //updates html
    updateCondOffersList(){
        var selectedOffers = this.getSelectedConditionalOffers();//previous selected offers

        var cOffersList = document.querySelector(this.getSelector('.pmdrs-cond-offers-list'));
        var cOffersContainer = cOffersList.closest('.pmdrs-incentives-container');
        //set default value
        cOffersList.innerHTML = "";
        DOMHelper.addClass(cOffersContainer, "d-none");

        var currentType = this.app.dealPage.dealType;//using current deal type
        var paymentData = this.app.paymentData[currentType];
        if(!paymentData) return;//skip, prevent errors. Cash type doesn't have payment data

        var conditionalOffers = paymentData.conditionalOffers;
        if(!conditionalOffers) return;//skip, prevent errors if currentType doesnt have offers fields

        var listHtml = "";
        for (const programId in conditionalOffers) {
            var isChecked = selectedOffers.hasOwnProperty(programId);
            var cOffer = conditionalOffers[programId];
            listHtml += `<li><label>
                    <input type="checkbox" value="${programId}" ${isChecked ? "checked" :""}>
                    <span class="offer-item-text" data-datalayer="${cOffer.programDescription} - ${FormatHelper.currencyFormat(cOffer.amount)}" >${cOffer.programDescription}</span>
                    <span class='offer-item-amout'>${FormatHelper.currencyFormat(cOffer.amount)}</span>
                    </label></li>`;
        }
        if(listHtml.length){
            cOffersList.innerHTML = listHtml;
            DOMHelper.removeClass(cOffersContainer, "d-none");
            this.registerCondOfferItemHandlers();
            this.registerDatalayerEvents();
        }
    }

    getCurrentPaymentData(){
        var currentType = this.app.dealPage.dealType;
        let paymentData = this.app.paymentData[currentType];
        return paymentData;
    }

    //updates html
    updateOffersList(){
        var incentivesList = document.querySelector(this.getSelector('.pmdrs-offers-list'));
        var incentivesContainer = incentivesList.closest('.pmdrs-incentives-container');
        //set default value
        incentivesList.innerHTML = "";
        DOMHelper.addClass(incentivesContainer, "d-none");

        var paymentData = this.getCurrentPaymentData();
        if(!paymentData) return;//skip, prevent errors. Cash type doesn't have payment data

        var incentives = paymentData.incentives;
        if(!incentives) return;//skip, prevent errors if currentType doesnt have offers fields

        var listHtml = "";
        for (const programId in incentives) {
            var incentive = incentives[programId];
            listHtml += `<li><label>
                    <span class="offer-item-text" >${incentive.programDescription}</span>
                    <span class='offer-item-amout'>${FormatHelper.currencyFormat(incentive.amount)}</span>
                    </label></li>`;
        }
        if(listHtml.length){
            incentivesList.innerHTML = listHtml;
            DOMHelper.removeClass(incentivesContainer, "d-none");
        }
    }

    registerDatalayerEvents() {
        let offersClickEvents = [
            { selector: '.your-payment-section .pmdrs-cond-offers-list span.offer-item-text', section: "payment", element: 'offers click'},
        ];
        this.app.pmDRSDatalayer.addExternalHandlers(offersClickEvents);
    }

    registerCondOfferItemHandlers(){
        var $this = this;
        var currentType = this.app.dealPage.dealType;//using current deal type 
        var onChange = function(event){
            $this.updateMonthlyPayment(currentType, undefined, 'conditional_offer_change');

            //datalayer OFFER ADD REMOVE
            let input = event.target;                
            let offerName = input.nextElementSibling.textContent.replace(" ",'-').toLowerCase();
            let btnText = `conditional-offer-${offerName}-removed`;
            if(input.checked){
                btnText = `conditional-offer-${offerName}-added`;
            }
            $this.app.adobeDtmDatalayer.fireEvent('buttonClick',{btnText});
        }
        //checkbox onchange
		DOMHelper.addHandler(this.getSelector('.pmdrs-cond-offers-list input'), 'change', onChange);	

    }

    //@return object key by programId 
    getSelectedConditionalOffers(){
        var currentType = this.app.dealPage.dealType;//using current deal type 
        var paymentData = this.app.paymentData[currentType];
        if(!paymentData) return{};//skip, prevent errors. Cash type doesn't have payment data

        var conditionalOffers = paymentData.conditionalOffers;
        if(!conditionalOffers) return {};//skip, prevent errors if currentType doesnt have offers fields

        var selectedConditionalOffers = {};
        var selectedItems = document.querySelectorAll(this.getSelector('.pmdrs-cond-offers-list input:checked'));
        selectedItems.forEach(selectedItem => {//checkboxes
            let cOffer = conditionalOffers[selectedItem.value];
            if(!cOffer) return;//skip, needed because current type could not be aligned with current offers in html
            selectedConditionalOffers[cOffer.programId] = cOffer;
        })
        return selectedConditionalOffers;
    }

    getSelectedConditionalOffersTotal(){        
        var total = 0;
        var selectedOffers = this.getSelectedConditionalOffers();
        for(const programId in selectedOffers){
            total+= selectedOffers[programId].amount;
        }
        return total;
    }

    getDepositAmountField(){
        return document.querySelector(this.getSelector("#depositAmountInput"));
    }

    showDownPaymentLoading(){
        var loading = document.querySelector(this.getSelector(".down-payment-loading"));
        loading.style.display = "block";        
    }

    hideDownPaymentLoading(){
        var loading = document.querySelector(this.getSelector(".down-payment-loading"));
        loading.style.display = "none";        
    }

    showLoading(type) {
        document.querySelector(this.getSelector("." + type + "-loading")).style.display = "block";
    }

    hideLoading(type) {
        console.log(type);
        document.querySelector(this.getSelector("." + type + "-loading")).style.display = "none";
    }

    addPaymentElement() {
        var $this = this;
        if (this.addingPaymentElement) {
            return;
        }
        this.showDownPaymentLoading();
        this.addingPaymentElement = true;
        var depositField = this.getDepositAmountField();

        //DISABLE APPLY BTN
        var applyButton = document.querySelector(this.getSelector(".apply-down-payment-button"));
        applyButton.disabled = true;
        DOMHelper.removeClass(applyButton, "bg-blue");

        var cashDown = depositField.value;
        this.downPaymentDeposit = cashDown;
        this.app.pmdrs.pmApi.getPaymentIntent({ amount: cashDown }, (response) => {
            response = JSON.parse(response);
            const clientSecret = response.clientSecret;
            const appearance = {
                /* appearance */
            };
            const options = {
                fields: {
                    billingDetails: {
                        address: {
                            country: "never",
                        },
                    },
                },
            };
            var depositAmountValue = document.querySelector($this.getSelector(".payment-amount-value"));
            depositAmountValue.innerHTML = FormatHelper.currencyFormat(cashDown);

            $this.stripeElements = $this.stripe.elements({ clientSecret, appearance });
            const paymentElement = $this.stripeElements.create("payment", options);
            paymentElement.mount($this.getSelector("#payment-element"));
            $this.hideDownPaymentLoading()

            this.addingPaymentElement = false;
            //RESET APPLY BTN
            applyButton.disabled = false;
            DOMHelper.addClass(applyButton, "bg-blue");

            //DATALAYER
            // Listen for payment method changes
            paymentElement.on('change', function(event) {
                if (event.value && event.value.type) {
                    let paymentType = event.value.type;
                    console.log('User selected:', paymentType);
                    $this.app.adobeDtmDatalayer.fireEvent('buttonClick',{btnText:'deposit-type-'+paymentType})
                }
            });
        });
    }

    setCashOptionPayment(){ //deprecated, driver should return something to match workflow with other types       
        // document.querySelector(dealPage.getSelector("#credit-score-dealPage")).style.display = "none";
        // document.querySelectorAll(dealPage.getSelector("span.balloon-text-container")).forEach((elem) => {
        //     elem.style.display = "none";
        // });
        this.hideMyPaymentError('cash');
        this.updateCashBox();
        this.updateMyPaymentValues();
        this.updateCondOffersList();
        this.updateOffersList();
        // TAXES
        this.stopUsingTaxes();
        // document.querySelector(dealPage.getSelector(".vehicle-lease-type-months")).style.display = "none";
        // document.querySelector(dealPage.getSelector(".vehicle-lease-type-taxes")).style.display = "none";
        // let monthsHeader = document.querySelector(dealPage.getSelector(".vehicle-lease-type-taxes"));
        // monthsHeader.classList.remove("payment-monts-value-before");
    }

    selectDealType(type, updatePaymentFlag = true, trigger = 'payment_type_switch') {
        let background = this.app.config.vehicle.make.toLowerCase() == "indian motorcycle" ? "indian-background" : "bmw-background";
        DOMHelper.removeClass(this.getSelector('.payment-option-box'), background);
        DOMHelper.removeClass(this.getSelector('.payment-option-box'), 'active');
        this.app.dealPage.setDealType(type);
        this.setDefaultDownPayment(); //this.calculateDownPayment();
        this.populateCreditScoreSelect();
        var boxSelector = `.${type}-box`; 
        switch(type){
            case 'cash':
                // boxSelector = '.cash-box';
                DOMHelper.addClass(this.getSelector('.apr'), 'd-none');
                // this.setCashOptionPayment();//temp disabled by jd to align cash with other payments process, to call apis, taxes, etc
                break;
            // case 'balloon': boxSelector = '.easy-ride-box'; break;
            // case 'lease': boxSelector = '.lease-box'; break;                                                               
            // case 'premier':
            //     // TO DO: populate credit score for premier
            //     boxSelector = '.premier-box';                
            //     break;            
            // case 'ttf':
            //     boxSelector = '.ttf-box';
            //     break;
        }

        if(updatePaymentFlag){//type != 'cash' &&
            this.updateMonthlyPayment(type, undefined, trigger);
            DOMHelper.removeClass(this.getSelector('.apr'), 'd-none');
        }
        DOMHelper.addClass(this.getSelector(boxSelector), 'active');
        DOMHelper.addClass(this.app.getSelector(".payment-option-box.active"), background);
        return this;
    }

    /**
     * update boxes and global values arround the whole deal page using this.app.paymentData      
     */
    refreshAllPayments(trigger = 'recalculation'){
        // if ((this.app.isBMW() && !this.app.isVehicleDucati()) || 
        //     this.app.isBMWPolaris() && !this.app.isVehicleDucati()) {
        //     this.updateMonthlyPayment('finance');
        //     this.updateMonthlyPayment('balloon');
        // } else if (this.app.isVehicleDucati()) {
        //     this.updateMonthlyPayment('finance');
        //     this.updateMonthlyPayment('premier');
        // } else if (this.app.isVehicleTriumph()) {
        //     this.updateMonthlyPayment('finance');
        //     this.updateMonthlyPayment('ttf');
        // } else if (this.app.isVehicleOnlyFinance(this.app.config.vehicle.make)) {
        //     this.updateMonthlyPayment('finance');
        // } else {
        //     this.updateMonthlyPayment('finance');
        //     this.updateMonthlyPayment('lease');
        // }
        // this.updateMonthlyPayment('cash');

        //UPDATE ALL EXISTING PAYMENTS
        this.app.pmdrs.allDealTypes.forEach(dealType => {
            if(this.app.paymentData[dealType]){
                this.updateMonthlyPayment(dealType, undefined, trigger);
            }
        });
    }

    preCachePayments(){        
        var $this = this;
        if(!this.app.dealPage.isAccessoriesSectionAllowed()) return;
        var accessoriesPrices = [];

        this.app.dealPage.accessoriesSection.accessories.forEach((accessory) => {
            accessoriesPrices.push(accessory.price);
        });

        console.log(accessoriesPrices);
        this.app.pmdrs.allDealTypes.forEach(dealType => {
            if($this.app.paymentData[dealType]){                
                var paymentData = $this.getPaymentParams(dealType);
                $this.app.pmdrs.dataDriver.precachePayments(paymentData, dealType, accessoriesPrices);
            }            
        });
    }    

    eventHandlers() {
        var $this = this;        
        this.getRetailingTypeSelect("term").addEventListener("change", () => {
            $this.termTouched = true;
            $this.selectDealType('finance', true, 'term_change')
        });

        this.getRetailingTypeSelect("term-balloon").addEventListener("change", () => {
            $this.termTouched = true;
            $this.selectDealType('balloon', true, 'term_change')
        });

        this.getRetailingTypeSelect("term-lease").addEventListener("change", () => {
            $this.termTouched = true;
            $this.selectDealType('lease', true, 'term_change')
        });

        this.getRetailingTypeSelect("mpy-lease").addEventListener("change", () => {
            $this.mpyTouched = true;
            $this.selectDealType('lease', true, 'mpy_change')
        });

        // this.getRetailingTypeSelect("term-premier").addEventListener("change", () => {
        //     $this.selectDealType('premier');
        // });

        // this.getRetailingTypeSelect("term-ttf").addEventListener("change", () => {
        //     $this.selectDealType('ttf');
        // });

		DOMHelper.addHandler(this.getLenderSelect('finance'), 'change', ()=>{
            $this.selectDealType('finance', true, 'lender_change');//fire update payment
        });

        DOMHelper.addHandler(this.getLenderSelect('lease'), 'change', ()=>{
            $this.selectDealType('lease', true, 'lender_change');//fire update payment
        });

        // this.getRetailingTypeSelect("term-lease").addEventListener("change", refreshFinanceMonthlyPayment);
        this.getRetailingTypeSelect("credit-score")
        .addEventListener("change", () => { $this.creditScoreTouched = true; $this.refreshAllPayments('credit_score_change') });

        this.getCashDownInput()
            ?.addEventListener("change", () => { $this.cashDownTouched = true; $this.refreshAllPayments('down_payment_change') });

        //make a deposit
        DOMHelper.addHandler(this.getSelector("#payment-deposit"), "change", (event) => {
            $this.makeDownPaymentTouched = true;
            $this.makeDownPayment = event.target.value == 'yes';
            let body = document.querySelector($this.getSelector(".down-payment-body"));
            if($this.makeDownPayment){                
                body.style.display = "block";
                $this.addPaymentElement();
                $this.getDepositAmountField().disabled = false;
            }else{
                body.style.display = "none";
                $this.getDepositAmountField().disabled = true;
            }
        });

        // Learn More on Easy Ride Box
        DOMHelper.addHandler(this.getSelector(".balloon-learnmore-btn"), "click", () => {
            this.easyRideInfoModal.show();
        });

        // Fees & Taxes collapse/expand toggle
        DOMHelper.addHandler(this.getSelector(".fees-details-toggle"), "click", () => {
            const feesDetails = document.querySelector(this.getSelector(".pmdrs-fees-details"));
            if (feesDetails) {
                feesDetails.classList.toggle('is-collapsed');
            }
        });

        let refreshPaymentElement = function () {
            var minValue = 100;
            var depositField = document.querySelector($this.getSelector("#depositAmountInput"));

            if (depositField.value < minValue) {
                depositField.reportValidity();
                return;
            }
            //If down payment section is active, render a new payment
            if ($this.makeDownPayment) {
                $this.addPaymentElement();
            }
        };

        DOMHelper.addHandler($this.getSelector(".apply-down-payment-button"), "click", refreshPaymentElement);
        DOMHelper.addHandler($this.getSelector("#depositAmountInput"), "change", refreshPaymentElement);

        //PAYMENT OPTION BOX CLICK        
        DOMHelper.addHandler($this.getSelector(".payment-option-box .click-curtain"), "click", (e)=> {
            if(!$this.enabled) return;
            let type = e.target.parentElement.dataset.type;
            $this.app.dealPage.dealTypeTouched = true;
            $this.selectDealType(type);
        });

        DOMHelper.addHandler($this.getSelector(".submit-button"), "click", ()=>{
            if(!$this.enabled) return;

            if ($this.app.siteSettings.sectionsUnlockedByDefault) {
                // remote control for the contact form's own submit — same validated
                // action, just triggerable from down here too. On failure, scroll up
                // to the form so the user sees which fields errored.
                let contactFormSection = $this.app.dealPage.contactFormSection;
                if (contactFormSection.validateContactInformation()) {
                    contactFormSection.submitContactInformation();
                } else {
                    document.querySelector($this.app.getSelector(".contact-form-section"))
                        .scrollIntoView({ behavior: "smooth", block: "start" });
                }
                return;
            }

            let dealPageForm = document.querySelector($this.app.getSelector(".deal-page-form"));
            DOMHelper.triggerEvent(dealPageForm, 'submit');
        });

        DOMHelper.addHandler($this.getSelector(".start-application-button"), "click", () => {
            window.open($this.getStartApplicationButtonUrl(), "_blank");
            $this.app.shiftDatalayer.fireEvent('drCreditAppStart', {});
        });


        DOMHelper.addHandler($this.getSelector(".balloon-disclaimer-btn"), "click", ()=>{                        
            $this.app.dealPage.openDisclaimer('balloon');
        });

        DOMHelper.addHandler($this.getSelector(".finance-disclaimer-btn"), "click", () => {
            $this.app.dealPage.openDisclaimer('finance');
        });

        // DOMHelper.addHandler($this.getSelector(".premier-disclaimer-btn"), "click", () => {
        //     $this.app.dealPage.openDisclaimer('premier');
        // });

        // DOMHelper.addHandler($this.getSelector(".ttf-disclaimer-btn"), "click", () => {
        //     $this.app.dealPage.openDisclaimer('ttf');
        // });

        DOMHelper.addHandler($this.getSelector(".cash-disclaimer-btn"), "click", () => {
            $this.app.dealPage.openDisclaimer('cash');
        });

        DOMHelper.addHandler($this.getSelector(".lease-disclaimer-btn"), "click", () => {
            $this.app.dealPage.openDisclaimer('lease');
        });

        DOMHelper.addHandler($this.getSelector(".summary-disclaimer .summary-disclaimer-header"), "click", (event) => {
            const clickedElement = event.currentTarget;
            const content = clickedElement.nextElementSibling;

            console.log(content);
            if (content && content.classList.contains('summary-disclaimer-content')) {
                this.slideToggle(content, 300);
                clickedElement.classList.toggle('active');
            }
        });

        // zip code event
        DOMHelper.addHandler(this.getTaxesBtn(), "click", () => {
            if(!$this.enabled) return;
            $this.taxesBtnClickHandler();
        });

        return;
        this.getRetailingTypeSelect("miles-per-year").addEventListener("change", refreshFinanceMonthlyPayment);

        let paymentData = this.app.paymentData;
    }

    slideToggle(element, duration = 300) {
        if (window.getComputedStyle(element).display === 'none' || element.classList.contains('d-none')) {
            element.style.removeProperty('display');
            element.classList.remove('d-none'); // Remove the hiding utility class

            let height = element.scrollHeight; // Get the natural height

            element.style.overflow = 'hidden';
            element.style.maxHeight = '0';
            element.style.paddingTop = '0';
            element.style.paddingBottom = '0';
            element.style.transitionProperty = 'max-height, padding-top, padding-bottom';
            element.style.transitionDuration = duration + 'ms';
            element.style.transitionTimingFunction = 'ease-in-out';
            
            // Force reflow
            element.offsetHeight; 

            // Animate to full height
            element.style.maxHeight = height + 'px';
            element.style.paddingTop = ''; // Restore padding/set to default
            element.style.paddingBottom = ''; // Restore padding/set to default

            // Clean up styles after animation (optional, for performance)
            window.setTimeout(() => {
                element.style.removeProperty('max-height');
                element.style.removeProperty('overflow');
                element.style.removeProperty('transition-duration');
                element.style.removeProperty('transition-property');
                element.style.removeProperty('transition-timing-function');
            }, duration);

        } else {
            // Slide Up (hide)
            element.style.overflow = 'hidden';
            element.style.maxHeight = element.scrollHeight + 'px';
            element.style.transitionProperty = 'max-height, padding-top, padding-bottom';
            element.style.transitionDuration = duration + 'ms';
            element.style.transitionTimingFunction = 'ease-in-out';
            
            // Force reflow
            element.offsetHeight; 

            // Animate to 0 height
            element.style.maxHeight = '0';
            element.style.paddingTop = '0';
            element.style.paddingBottom = '0';

            // Add hiding class after animation completes
            window.setTimeout(() => {
                element.classList.add('d-none');
                element.style.removeProperty('padding-top');
                element.style.removeProperty('padding-bottom');
                element.style.removeProperty('max-height');
                element.style.removeProperty('overflow');
                element.style.removeProperty('transition-duration');
                element.style.removeProperty('transition-property');
                element.style.removeProperty('transition-timing-function');
            }, duration);
        }
    }

    showTaxesError(flag){
        document.querySelector(this.getSelector('#taxes-error')).style.display = flag ? 'block' : 'none';
    }

    hideSubmitButtonError(){             
        var p = document.querySelector(this.app.getSelector('#submit-button-error'));        
        p.style.display = 'none';
    }

    showSubmitButtonError(msg){
        var p = document.querySelector(this.getSelector('#submit-button-error'));        
        p.textContent = msg;
        p.style.display = 'block';
    }

    hideMakeDepositError(){             
        var p = document.querySelector(this.getSelector('#make-deposit-error'));        
        p.style.display = 'none';
    }

    showMakeDepositError(msg){
        var p = document.querySelector(this.getSelector('#make-deposit-error'));        
        p.textContent = msg;
        p.style.display = 'block';
    }

    showUnablePaymentMessage(type, message = null){
        let msg = "";
        msg = 'We are unable to provide an online quote on this vehicle using the information supplied';
        msg = message == null ? msg : message;
        var element = document.querySelector(this.app.getSelector(`.${type}-box .box-error-msg`));
        element.textContent = msg;
        DOMHelper.removeClass(element,"dn");
        DOMHelper.addClass(this.getSelector(`.${type}-box-value`),"dn");
    }

    hideUnablePaymentMessage(type){
        DOMHelper.addClass(
            this.app.getSelector(`.${type}-box .box-error-msg`),
            "dn"
        );
        DOMHelper.removeClass(this.getSelector(`.${type}-box-value`),"dn");
    }

    // shows error, disable buttons, hide things, update texts
    showMyPaymentError(type){
        var currentType = this.app.dealPage.dealType;
        if(type != currentType) return;//skip if it's not selected 

        //show error
        const msg = 'We are unable to provide an online quote';
        var element = document.querySelector(this.app.getSelector(`.mypayment-error`));
        element.textContent = msg;
        DOMHelper.removeClass(element,"dn");

        //hide things
        DOMHelper.addClass(this.app.getSelector(`.mypayment-value`),"dn");

        // UPDATE minimal values
        var paymentOptionText = this.getPaymentOptionText(currentType);
        DOMHelper.setInnerHTML(this.app.getSelector(".payment-option"), paymentOptionText);        
        DOMHelper.setInnerHTML(this.app.getSelector(".mypayment-label"), paymentOptionText);

        //disable submit
        this.disableSubmitBtn();
        this.showSubmitButtonError(msg);
    }

    //hide errors and reset buttons
    hideMyPaymentError(type){
        var currentType = this.app.dealPage.dealType;
        if(type != currentType) return;//skip if it's not selected

        DOMHelper.addClass(
            this.app.getSelector(`.mypayment-error`),
            "dn"
        );
        DOMHelper.removeClass(this.app.getSelector(`.mypayment-value`),"dn");

        //reset submit
        this.enableSubmitBtn();
        this.hideSubmitButtonError();
    }

    getDealerZipCode() {
        return this.app.pmdrs.config.dealerZipCode;
    }

    //TODO move PM logic. Inside this function is the PM taxes logic, it should be in the drive but seems difficult
    taxesBtnClickHandler() {
        this.feesAndTaxesCompleted = true;
        if(!this.app.pmdrs.dataDriver.isPixelmotion()){
            var currentType = this.app.dealPage.dealType;//using current deal type 
            // if(currentType == "cash") return;//skip for now. We need to stop avoiding cash everywhere
            this.taxes = !this.taxes;//toggle
            this.updateMonthlyPayment(currentType, undefined, 'apply_taxes');
            return;//stop
        }
        // ONLY PIXELMOTION DRIVER
        this.showTaxesError(false);

        if (!this.isUsingTaxes()) {//APPLY TAXES            
            // let zipcCodeValue = document.querySelector(this.getSelector("#tfZipCode")).value;
            let zipcCodeValue = this.getDealerZipCode();
            console.log(zipcCodeValue);
            this.app.pmdrs.pmSalesApi.getTaxesByZipcode(
                zipcCodeValue,
                (response) => {
                    let taxes = JSON.parse(response);
                    if (taxes.length == 0) {
                        this.showTaxesError(true);
                    } else {
                        this.taxes = true;
                        taxes = taxes[0];
                        let totalTaxes = taxes.estimatedCombinedRate;

                        // let fees = this.app.config.vehicle.finalPrice * totalTaxes;
                        this.taxesValue = totalTaxes;
                        //is it correct adding fees to finalPrice? it works by the moment
                        // this.app.config.vehicle.finalPrice += fees;                    
                        this.setTaxesBtnText(this.app.config.vehicle.finalPrice * this.taxesValue);
                        this.refreshAllPayments('apply_taxes')
                    }
                },
                (error) => {
                    console.log(error);
                    this.showTaxesError(true);                
                }
            );
        } else {//REMOVE TAXES           
            this.stopUsingTaxes();
            console.log("taxes value: " + this.taxesValue);
            //is it correct adding fees to finalPrice? it works by the moment
            // this.app.config.vehicle.finalPrice -= this.taxesValue;
            this.taxesValue = 0;
            this.refreshAllPayments('apply_taxes')
        }
    }

    hideFeesAndTaxesDetails(){
        DOMHelper.addClass(this.getSelector(".pmdrs-fees-details"), 'd-none');
    }

    getFeesAndTaxesList(){
        var currentType = this.app.dealPage.dealType;
        let paymentData = this.app.paymentData[currentType];
        return paymentData.feesAndTaxesList || null;
    }

    updateFeesAndTaxesDetails(feesAndTaxesList){
        if(!feesAndTaxesList) return;//skip
        DOMHelper.removeClass(this.getSelector(".pmdrs-fees-details"), 'd-none');
        DOMHelper.addClass(this.getSelector(".pmdrs-fees-details"), 'is-collapsed');

        let ul = document.querySelector(this.getSelector(".pmdrs-fees-details ul"));
        var listHtml = "";
        feesAndTaxesList.forEach(detail=>{
            listHtml+=`<li>
            <span>${detail.label}</span>
            <span>${FormatHelper.currencyFormat(detail.amount)}</span>
            </li>`;
        });
        ul.innerHTML = listHtml;
    }

    getTaxesBtn(){
        if(this.app.pmdrs.dataDriver.isLenderDesk()){
            return document.querySelector(this.app.getSelector(".apply-taxes-button2"));//think a better classname
        }
        // DEFAULT
        return document.querySelector(this.app.getSelector(".apply-taxes-button"));
    }
    
    resetTaxesBtn(){
        DOMHelper.addClass(this.app.getSelector(".taxes"), "d-none");//temp,  need improves and a placement place maybe
        let taxesBtn = this.getTaxesBtn();
        if (!taxesBtn) return;
        taxesBtn.innerHTML = this.app.pmdrs.dataDriver.getTaxesBtnText();
        DOMHelper.removeClass(taxesBtn, 'remove-taxes');
    }

    updateTaxesTotalDisplay(taxesAmount){
        DOMHelper.setInnerHTML(this.app.getSelector(".taxes"), "Taxes: " + FormatHelper.currencyFormat(taxesAmount));
        DOMHelper.removeClass(this.app.getSelector(".taxes"), "d-none");                           
    }

    setZipCodeText() {
        let zipCodeElem = document.querySelector(this.getSelector(".contact-form-text"));
        let text = "";
        if (this.app.pmdrs.config.accountId == "delamomotorsports") {
            text = "Enter Zip Code to Estimate Taxes";
            zipCodeElem.innerHTML = text;
            return;
        }
        text = "Your zip code will be used to calculate the estimated sales tax.";
        zipCodeElem.innerHTML = text;
    }

    setTaxesBtnText(taxesAmount){
        this.updateTaxesTotalDisplay(taxesAmount);//temp, need improves and a placement place maybe
        let taxesBtn = this.getTaxesBtn();
        if (!taxesBtn) return;
        taxesBtn.innerHTML = "Remove " + FormatHelper.currencyFormat(taxesAmount) + " in taxes";
        DOMHelper.addClass(taxesBtn, 'remove-taxes');
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAt + " " + selector);
    }

    getSubmitBtn() {
        return document.querySelector(this.getSelector('.submit-button'));
    }

    enableSubmitBtn(){
        var btn = this.getSubmitBtn();
        DOMHelper.removeClass(btn, 'disabled')
    }

    disableSubmitBtn(){
        var btn = this.getSubmitBtn();
        DOMHelper.addClass(btn, 'disabled')
    }

    setSubmitBtnSent(){
        var btn = this.getSubmitBtn();
        if (!btn) return;
        btn.innerHTML = 'Sent';
        DOMHelper.addClass(btn, 'submit-sent');
    }

    isUsingTaxes(){
        return this.taxes;
    }

    stopUsingTaxes(){
        this.taxes = false;
        this.resetTaxesBtn();
        this.hideFeesAndTaxesDetails();
    }

    enableTaxesBtn(){
        let taxesBtn = this.getTaxesBtn();
        DOMHelper.removeClass(taxesBtn, 'disabled');
    }

    disableTaxesBtn(){
        DOMHelper.addClass(this.getTaxesBtn(), 'disabled');
    }

    enableConditionalOffers(){
        DOMHelper.removeClass(this.getSelector('.pmdrs-incentives-container'), 'disabled-section');
    }

    disableConditionalOffers(){
        DOMHelper.addClass(this.getSelector('.pmdrs-incentives-container'), 'disabled-section');
    }

     /**
     * to disable the whole section     
     */
    disable(){
        this.enabled = false;
        DOMHelper.addClass(this.getSelector('.payment-option-box'), 'disabled');
        DOMHelper.addClass(this.getSelector('select'), 'disabled');
        this.disableSubmitBtn();
        DOMHelper.addClass(this.getSelector(''), 'disabled-section');
    }

    /**
     * to enable the whole section     
     */
    enable() {
        this.enabled = true;
        DOMHelper.removeClass(this.getSelector('.payment-option-box'), 'disabled');
        DOMHelper.removeClass(this.getSelector('select'), 'disabled');
        this.enableSubmitBtn();
        DOMHelper.removeClass(this.getSelector(''), 'disabled-section');
    }
}
